"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stockpulse REST API
 * API signatures generated at 2023-11-16T17:06:58+01:00
 *
 * The version of the OpenAPI document: 6
 * Contact: support@stockpulse.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntitiesApiFactory = exports.EntitiesApiFp = exports.EntitiesApiAxiosParamCreator = exports.BuzzSentimentApi = exports.BuzzSentimentApiFactory = exports.BuzzSentimentApiFp = exports.BuzzSentimentApiAxiosParamCreator = exports.AuthorsApi = exports.AuthorsApiFactory = exports.AuthorsApiFp = exports.AuthorsApiAxiosParamCreator = exports.AIApi = exports.AIApiFactory = exports.AIApiFp = exports.AIApiAxiosParamCreator = exports.UserGroupType = exports.Trophy = exports.Trend = exports.TransactionType = exports.TransactionTransactionEnum = exports.StrikeMethod = exports.StatsSearchAuthorRequestOrderByEnum = exports.SignalPolicy = exports.SearchSearchMessageRequestOrderByEnum = exports.SearchSearchMessageRequestLangEnum = exports.SearchSearchMessageRequestTypeEnum = exports.SMADataCurrentKindEnum = exports.RuleRuleSetInnerComparatorEnum = exports.RuleRuleSetInnerMetricEnum = exports.RuleRuleTypeEnum = exports.RuleScopeEnum = exports.ReportModelName = exports.RatingForTitleSmaPriceEnum = exports.RatingForTitleSentPulsePicksEnum = exports.RatingForTitleSentBuzzEnum = exports.RatingForTitleSectorPriceEnum = exports.RatingForTitleRsiPriceEnum = exports.RatingForTitlePeRatioEnum = exports.RatingForTitleOverallEnum = exports.RatingForTitleDividendEnum = exports.RatingForTitleAnalystsEnum = exports.QueryInfoStatusEnum = exports.Position = exports.PersonV6GenderEnum = exports.PersonGenderEnum = exports.OtherUserItemType = exports.ModelType = exports.MessageType = exports.EntityType = exports.CurrentPriceKindEnum = void 0;
exports.TopicsApiAxiosParamCreator = exports.SpecialSourcesApi = exports.SpecialSourcesApiFactory = exports.SpecialSourcesApiFp = exports.SpecialSourcesApiAxiosParamCreator = exports.RulesApi = exports.RulesApiFactory = exports.RulesApiFp = exports.RulesApiAxiosParamCreator = exports.PulseRatingsApi = exports.PulseRatingsApiFactory = exports.PulseRatingsApiFp = exports.PulseRatingsApiAxiosParamCreator = exports.PulsePicksApi = exports.PulsePicksApiFactory = exports.PulsePicksApiFp = exports.PulsePicksApiAxiosParamCreator = exports.PriceDataApi = exports.PriceDataApiFactory = exports.PriceDataApiFp = exports.PriceDataApiAxiosParamCreator = exports.NewsbotsApi = exports.NewsbotsApiFactory = exports.NewsbotsApiFp = exports.NewsbotsApiAxiosParamCreator = exports.KeyEventsV2Api = exports.KeyEventsV2ApiFactory = exports.KeyEventsV2ApiFp = exports.KeyEventsV2ApiAxiosParamCreator = exports.KeyEventsApi = exports.KeyEventsApiFactory = exports.KeyEventsApiFp = exports.KeyEventsApiAxiosParamCreator = exports.InventoryApi = exports.InventoryApiFactory = exports.InventoryApiFp = exports.InventoryApiAxiosParamCreator = exports.GazetteRecordsApi = exports.GazetteRecordsApiFactory = exports.GazetteRecordsApiFp = exports.GazetteRecordsApiAxiosParamCreator = exports.FinancialsBasicApi = exports.FinancialsBasicApiFactory = exports.FinancialsBasicApiFp = exports.FinancialsBasicApiAxiosParamCreator = exports.FinancialsAdvancedApi = exports.FinancialsAdvancedApiFactory = exports.FinancialsAdvancedApiFp = exports.FinancialsAdvancedApiAxiosParamCreator = exports.EntitiesApi = void 0;
exports.WatchlistsApi = exports.WatchlistsApiFactory = exports.WatchlistsApiFp = exports.WatchlistsApiAxiosParamCreator = exports.UserdataApi = exports.UserdataApiFactory = exports.UserdataApiFp = exports.UserdataApiAxiosParamCreator = exports.TradingOpportunitiesApi = exports.TradingOpportunitiesApiFactory = exports.TradingOpportunitiesApiFp = exports.TradingOpportunitiesApiAxiosParamCreator = exports.TopsFlopsApi = exports.TopsFlopsApiFactory = exports.TopsFlopsApiFp = exports.TopsFlopsApiAxiosParamCreator = exports.TopicsApi = exports.TopicsApiFactory = exports.TopicsApiFp = void 0;
const axios_1 = require("axios");
// URLSearchParams not necessarily used
// @ts-ignore
const url_1 = require("url");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.CurrentPriceKindEnum = {
    L: 'l',
    B: 'b',
    A: 'a'
};
/**
 * Type of entity.
 * @export
 * @enum {string}
 */
exports.EntityType = {
    Person: 'person',
    Class: 'class',
    Company: 'company',
    CryptoCurrency: 'crypto_currency',
    Derivative: 'derivative',
    Forex: 'forex',
    Index: 'index',
    RawMaterial: 'raw_material',
    Fund: 'fund',
    Unlisted: 'unlisted'
};
/**
 * Type of message.
 * @export
 * @enum {string}
 */
exports.MessageType = {
    Adhoc: 'adhoc',
    Blog: 'blog',
    Comments: 'comments',
    Filings: 'filings',
    ForumPosts: 'forum_posts',
    News: 'news',
    Tweets: 'tweets',
    Videos: 'videos'
};
/**
 * How model considers sentiment, on \'normal\', positive sentiment means \'buy signal\', on \'contra\' positive sentiment means \'sell signal\'.
 * @export
 * @enum {string}
 */
exports.ModelType = {
    Normal: 'normal',
    Contra: 'contra'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OtherUserItemType = {
    TaggedMessage: 'TaggedMessage',
    RankingItem: 'RankingItem',
    PollWinner: 'PollWinner'
};
exports.PersonGenderEnum = {
    Null: 'null',
    Male: 'male',
    Female: 'female'
};
exports.PersonV6GenderEnum = {
    Null: 'null',
    Male: 'male',
    Female: 'female'
};
/**
 * Position/signal for a title.
 * @export
 * @enum {string}
 */
exports.Position = {
    Buy: 'buy',
    Sell: 'sell',
    Flat: 'flat'
};
exports.QueryInfoStatusEnum = {
    New: 'new',
    Initialized: 'initialized',
    Failed: 'failed'
};
exports.RatingForTitleAnalystsEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitleDividendEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitleOverallEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitlePeRatioEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitleRsiPriceEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitleSectorPriceEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitleSentBuzzEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitleSentPulsePicksEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
exports.RatingForTitleSmaPriceEnum = {
    Buy: 'Buy',
    Hold: 'Hold',
    Sell: 'Sell'
};
/**
 * Name of the report model.
 * @export
 * @enum {string}
 */
exports.ReportModelName = {
    _10minute: '10minute',
    _1minute: '1minute',
    Daily5am: 'daily_5am',
    Daily2pm: 'daily_2pm',
    Daily5pm: 'daily_5pm',
    HourlyShortterm: 'hourly_shortterm',
    _10minuteScore2: '10minute_score_2',
    _10minuteScore4: '10minute_score_4',
    Daily5amScore2: 'daily_5am_score_2',
    Daily5amScore3: 'daily_5am_score_3',
    Daily5amScore4: 'daily_5am_score_4',
    Daily5amScore5: 'daily_5am_score_5',
    HourlyReddit: 'hourly_reddit',
    _10minuteReddit: '10minute_reddit',
    Daily5amReddit: 'daily_5am_reddit',
    _10minuteRedditWallstreetbets: '10minute_reddit_wallstreetbets',
    _10minuteStocktwits: '10minute_stocktwits',
    Daily5amStocktwits: 'daily_5am_stocktwits',
    Daily5amRedditWallstreetbets: 'daily_5am_reddit_wallstreetbets',
    Daily3am: 'daily_3am',
    _10minuteInvesting: '10minute_investing',
    Daily5amInvesting: 'daily_5am_investing',
    _10minuteXueqiu: '10minute_xueqiu',
    Daily5amXueqiu: 'daily_5am_xueqiu',
    _10minuteTwitter: '10minute_twitter',
    Daily5amTwitter: 'daily_5am_twitter',
    Daily5amDiscord: 'daily_5am_discord',
    _10minuteDiscord: '10minute_discord',
    Daily2pmDiscord: 'daily_2pm_discord',
    Daily5pmTelegram: 'daily_5pm_telegram',
    Daily5amTelegram: 'daily_5am_telegram',
    Daily5pmTiktok: 'daily_5pm_tiktok',
    Daily5amTiktok: 'daily_5am_tiktok',
    Daily5pmDiscord: 'daily_5pm_discord',
    Daily5amYoutube: 'daily_5am_youtube',
    Daily5pmYoutube: 'daily_5pm_youtube',
    Daily5amHotcopper: 'daily_5am_hotcopper',
    Daily5pmHotcopper: 'daily_5pm_hotcopper',
    Daily5am4chan: 'daily_5am_4chan',
    Daily5pm4chan: 'daily_5pm_4chan',
    Daily5amCoinmarketcap: 'daily_5am_coinmarketcap',
    Daily5pmCoinmarketcap: 'daily_5pm_coinmarketcap'
};
exports.RuleScopeEnum = {
    Watchlist: 'watchlist',
    Index: 'index',
    Class: 'class'
};
exports.RuleRuleTypeEnum = {
    BuzzPatterns: 'buzz_patterns',
    UnlistedFilter: 'unlisted_filter',
    UserMessages: 'user_messages'
};
exports.RuleRuleSetInnerMetricEnum = {
    B: 'b',
    S: 's'
};
exports.RuleRuleSetInnerComparatorEnum = {
    Gt: 'gt',
    Lt: 'lt',
    Eq: 'eq',
    F: 'f',
    R: 'r'
};
exports.SMADataCurrentKindEnum = {
    L: 'l',
    B: 'b',
    A: 'a'
};
exports.SearchSearchMessageRequestTypeEnum = {
    Adhoc: 'adhoc',
    Blog: 'blog',
    Comments: 'comments',
    Filings: 'filings',
    ForumPosts: 'forum_posts',
    News: 'news',
    Tweets: 'tweets',
    Videos: 'videos',
    All: 'all'
};
exports.SearchSearchMessageRequestLangEnum = {
    En: 'en',
    De: 'de',
    Cn: 'cn',
    Da: 'da',
    Ru: 'ru',
    Fi: 'fi',
    Sv: 'sv',
    Is: 'is',
    Tr: 'tr',
    Es: 'es',
    Fr: 'fr',
    Ja: 'ja'
};
exports.SearchSearchMessageRequestOrderByEnum = {
    Score: 'score',
    ScoreAsc: 'score_asc',
    MessageTime: 'message_time',
    MessageTimeAsc: 'message_time_asc'
};
/**
 * Allocation policy when new signals arrive, e. g. PORTFOLIO assigns an equal amount of the available NAV to each position.
 * @export
 * @enum {string}
 */
exports.SignalPolicy = {
    Portfolio: 'PORTFOLIO',
    PortfolioAdjust: 'PORTFOLIO_ADJUST',
    Ignore: 'IGNORE',
    Turn: 'TURN',
    Adjust: 'ADJUST',
    Hold: 'HOLD'
};
exports.StatsSearchAuthorRequestOrderByEnum = {
    Score: 'score',
    ScoreAsc: 'score_asc',
    Total: 'total',
    TotalAsc: 'total_asc'
};
/**
 * How to simulate execution price from open/high/low/close values.
 * @export
 * @enum {string}
 */
exports.StrikeMethod = {
    Open: 'OPEN',
    Worst: 'WORST',
    Best: 'BEST',
    Close: 'CLOSE',
    Signal: 'SIGNAL',
    Avg: 'AVG',
    Middle: 'MIDDLE'
};
exports.TransactionTransactionEnum = {
    Buy: 'Buy',
    Sale: 'Sale',
    OptionExercise: 'Option Exercise'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TransactionType = {
    Wager: 'wager',
    Tag: 'tag',
    Payment: 'payment',
    Grant: 'grant',
    Reward: 'reward'
};
/**
 * Trend for a financial entity, e.g. a stock or crypto currency, indicating whether its price is expected to rise, fall or move sidewards.
 * @export
 * @enum {string}
 */
exports.Trend = {
    Up: 'up',
    Down: 'down',
    Flat: 'flat'
};
/**
 * Trophy based on the ranking of a user.
 * @export
 * @enum {string}
 */
exports.Trophy = {
    Gold: 'gold',
    Silver: 'silver',
    Bronce: 'bronce'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UserGroupType = {
    Event: 'event',
    UserGroup: 'userGroup',
    Poll: 'poll'
};
/**
 * AIApi - axios parameter creator
 * @export
 */
const AIApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Use Stockpulse LLM to generate an executive summary.
         * @summary Generate executive summary for the given input using a Large Language Model
         * @param {GenerateExecutiveSummaryAiRequest} generateExecutiveSummaryAiRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExecutiveSummaryAi: (generateExecutiveSummaryAiRequest, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateExecutiveSummaryAiRequest' is not null or undefined
            (0, common_1.assertParamExists)('generateExecutiveSummaryAi', 'generateExecutiveSummaryAiRequest', generateExecutiveSummaryAiRequest);
            const localVarPath = `/ai/textgen/executive-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generateExecutiveSummaryAiRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Use Stockpulse LLM to generate a list of topics.
         * @summary Generate list of topics for the given input using a Large Language Model
         * @param {GenerateTopicsListAiRequest} generateTopicsListAiRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTopicsListAi: (generateTopicsListAiRequest, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'generateTopicsListAiRequest' is not null or undefined
            (0, common_1.assertParamExists)('generateTopicsListAi', 'generateTopicsListAiRequest', generateTopicsListAiRequest);
            const localVarPath = `/ai/textgen/topics-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(generateTopicsListAiRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AIApiAxiosParamCreator = AIApiAxiosParamCreator;
/**
 * AIApi - functional programming interface
 * @export
 */
const AIApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AIApiAxiosParamCreator)(configuration);
    return {
        /**
         * Use Stockpulse LLM to generate an executive summary.
         * @summary Generate executive summary for the given input using a Large Language Model
         * @param {GenerateExecutiveSummaryAiRequest} generateExecutiveSummaryAiRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExecutiveSummaryAi(generateExecutiveSummaryAiRequest, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateExecutiveSummaryAi(generateExecutiveSummaryAiRequest, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Use Stockpulse LLM to generate a list of topics.
         * @summary Generate list of topics for the given input using a Large Language Model
         * @param {GenerateTopicsListAiRequest} generateTopicsListAiRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTopicsListAi(generateTopicsListAiRequest, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.generateTopicsListAi(generateTopicsListAiRequest, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AIApiFp = AIApiFp;
/**
 * AIApi - factory interface
 * @export
 */
const AIApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AIApiFp)(configuration);
    return {
        /**
         * Use Stockpulse LLM to generate an executive summary.
         * @summary Generate executive summary for the given input using a Large Language Model
         * @param {GenerateExecutiveSummaryAiRequest} generateExecutiveSummaryAiRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateExecutiveSummaryAi(generateExecutiveSummaryAiRequest, format, options) {
            return localVarFp.generateExecutiveSummaryAi(generateExecutiveSummaryAiRequest, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Use Stockpulse LLM to generate a list of topics.
         * @summary Generate list of topics for the given input using a Large Language Model
         * @param {GenerateTopicsListAiRequest} generateTopicsListAiRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateTopicsListAi(generateTopicsListAiRequest, format, options) {
            return localVarFp.generateTopicsListAi(generateTopicsListAiRequest, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AIApiFactory = AIApiFactory;
/**
 * AIApi - object-oriented interface
 * @export
 * @class AIApi
 * @extends {BaseAPI}
 */
class AIApi extends base_1.BaseAPI {
    /**
     * Use Stockpulse LLM to generate an executive summary.
     * @summary Generate executive summary for the given input using a Large Language Model
     * @param {GenerateExecutiveSummaryAiRequest} generateExecutiveSummaryAiRequest Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    generateExecutiveSummaryAi(generateExecutiveSummaryAiRequest, format, options) {
        return (0, exports.AIApiFp)(this.configuration).generateExecutiveSummaryAi(generateExecutiveSummaryAiRequest, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Use Stockpulse LLM to generate a list of topics.
     * @summary Generate list of topics for the given input using a Large Language Model
     * @param {GenerateTopicsListAiRequest} generateTopicsListAiRequest Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AIApi
     */
    generateTopicsListAi(generateTopicsListAiRequest, format, options) {
        return (0, exports.AIApiFp)(this.configuration).generateTopicsListAi(generateTopicsListAiRequest, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AIApi = AIApi;
/**
 * AuthorsApi - axios parameter creator
 * @export
 */
const AuthorsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Network for specific author
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} author The username of an author publishing at a web source.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorGraphForAuthorsInSource: (source, author, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'source' is not null or undefined
            (0, common_1.assertParamExists)('getAuthorGraphForAuthorsInSource', 'source', source);
            // verify required parameter 'author' is not null or undefined
            (0, common_1.assertParamExists)('getAuthorGraphForAuthorsInSource', 'author', author);
            const localVarPath = `/authors/{source}/{author}/network`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)))
                .replace(`{${"author"}}`, encodeURIComponent(String(author)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Author stats for single author from a source
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} author The username of an author publishing at a web source.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorStatisticsForAuthorsInSource: (source, author, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'source' is not null or undefined
            (0, common_1.assertParamExists)('getAuthorStatisticsForAuthorsInSource', 'source', source);
            // verify required parameter 'author' is not null or undefined
            (0, common_1.assertParamExists)('getAuthorStatisticsForAuthorsInSource', 'author', author);
            const localVarPath = `/authors/{source}/{author}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)))
                .replace(`{${"author"}}`, encodeURIComponent(String(author)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Messages from specific authors
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} authors The username(s) of the author(s) for which data should be requested. Use comma to separate multiple author values.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForAuthorsInSource: (source, authors, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'source' is not null or undefined
            (0, common_1.assertParamExists)('getMessagesForAuthorsInSource', 'source', source);
            // verify required parameter 'authors' is not null or undefined
            (0, common_1.assertParamExists)('getMessagesForAuthorsInSource', 'authors', authors);
            const localVarPath = `/authors/{source}/{authors}/messages`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)))
                .replace(`{${"authors"}}`, encodeURIComponent(String(authors)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Stats for single author from a source
         * @param {StatsSearchAuthorRequest} statsSearchAuthorRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsSearchAuthor: (statsSearchAuthorRequest, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'statsSearchAuthorRequest' is not null or undefined
            (0, common_1.assertParamExists)('statsSearchAuthor', 'statsSearchAuthorRequest', statsSearchAuthorRequest);
            const localVarPath = `/authors/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(statsSearchAuthorRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AuthorsApiAxiosParamCreator = AuthorsApiAxiosParamCreator;
/**
 * AuthorsApi - functional programming interface
 * @export
 */
const AuthorsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AuthorsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Network for specific author
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} author The username of an author publishing at a web source.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorGraphForAuthorsInSource(source, author, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthorGraphForAuthorsInSource(source, author, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Author stats for single author from a source
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} author The username of an author publishing at a web source.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorStatisticsForAuthorsInSource(source, author, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAuthorStatisticsForAuthorsInSource(source, author, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Messages from specific authors
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} authors The username(s) of the author(s) for which data should be requested. Use comma to separate multiple author values.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForAuthorsInSource(source, authors, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessagesForAuthorsInSource(source, authors, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Stats for single author from a source
         * @param {StatsSearchAuthorRequest} statsSearchAuthorRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsSearchAuthor(statsSearchAuthorRequest, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.statsSearchAuthor(statsSearchAuthorRequest, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.AuthorsApiFp = AuthorsApiFp;
/**
 * AuthorsApi - factory interface
 * @export
 */
const AuthorsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AuthorsApiFp)(configuration);
    return {
        /**
         *
         * @summary Network for specific author
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} author The username of an author publishing at a web source.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorGraphForAuthorsInSource(source, author, startDate, endDate, format, options) {
            return localVarFp.getAuthorGraphForAuthorsInSource(source, author, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Author stats for single author from a source
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} author The username of an author publishing at a web source.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorStatisticsForAuthorsInSource(source, author, format, options) {
            return localVarFp.getAuthorStatisticsForAuthorsInSource(source, author, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Messages from specific authors
         * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
         * @param {string} authors The username(s) of the author(s) for which data should be requested. Use comma to separate multiple author values.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForAuthorsInSource(source, authors, startDate, endDate, limit, format, options) {
            return localVarFp.getMessagesForAuthorsInSource(source, authors, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Stats for single author from a source
         * @param {StatsSearchAuthorRequest} statsSearchAuthorRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statsSearchAuthor(statsSearchAuthorRequest, format, options) {
            return localVarFp.statsSearchAuthor(statsSearchAuthorRequest, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AuthorsApiFactory = AuthorsApiFactory;
/**
 * AuthorsApi - object-oriented interface
 * @export
 * @class AuthorsApi
 * @extends {BaseAPI}
 */
class AuthorsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Network for specific author
     * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
     * @param {string} author The username of an author publishing at a web source.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorsApi
     */
    getAuthorGraphForAuthorsInSource(source, author, startDate, endDate, format, options) {
        return (0, exports.AuthorsApiFp)(this.configuration).getAuthorGraphForAuthorsInSource(source, author, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Author stats for single author from a source
     * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
     * @param {string} author The username of an author publishing at a web source.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorsApi
     */
    getAuthorStatisticsForAuthorsInSource(source, author, format, options) {
        return (0, exports.AuthorsApiFp)(this.configuration).getAuthorStatisticsForAuthorsInSource(source, author, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Messages from specific authors
     * @param {string} source The domain of a web source, e.g. an online community, a news portal or a blog.
     * @param {string} authors The username(s) of the author(s) for which data should be requested. Use comma to separate multiple author values.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorsApi
     */
    getMessagesForAuthorsInSource(source, authors, startDate, endDate, limit, format, options) {
        return (0, exports.AuthorsApiFp)(this.configuration).getMessagesForAuthorsInSource(source, authors, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Stats for single author from a source
     * @param {StatsSearchAuthorRequest} statsSearchAuthorRequest Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorsApi
     */
    statsSearchAuthor(statsSearchAuthorRequest, format, options) {
        return (0, exports.AuthorsApiFp)(this.configuration).statsSearchAuthor(statsSearchAuthorRequest, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AuthorsApi = AuthorsApi;
/**
 * BuzzSentimentApi - axios parameter creator
 * @export
 */
const BuzzSentimentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Buzz and sentiment for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuzzSentimentForTitles: (idents, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'idents' is not null or undefined
            (0, common_1.assertParamExists)('getBuzzSentimentForTitles', 'idents', idents);
            const localVarPath = `/titles/{idents}`
                .replace(`{${"idents"}}`, encodeURIComponent(String(idents)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns tweets grouped by categories of authors. Available author categories: `news`, `analysts`, `traders`, `bloggers`.
         * @summary Messages by author category
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesMessagesForTitles: (ident, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getCategoriesMessagesForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/messages/categories`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary History of buzz and sentiment for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {string} [fields] Comma separated list of additional fields which should be included in the historic data. Available fields (see response definition for meaning of each field): [&#x60;total&#x60;,&#x60;pos&#x60;,&#x60;neg&#x60;,&#x60;smooth_total&#x60;,&#x60;smooth_pos&#x60;,&#x60;smooth_neg&#x60;,&#x60;avg_smooth_total&#x60;,&#x60;avg_smooth_pos&#x60;,&#x60;avg_smooth_neg&#x60;]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricBuzzSentimentForTitles: (idents, fields, startDate, endDate, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'idents' is not null or undefined
            (0, common_1.assertParamExists)('getHistoricBuzzSentimentForTitles', 'idents', idents);
            const localVarPath = `/titles/{idents}/history`
                .replace(`{${"idents"}}`, encodeURIComponent(String(idents)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (fields !== undefined) {
                localVarQueryParameter['fields'] = fields;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Buzz and sentiment for all lists
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLists: (partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/lists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Buzz and sentiment for a single list and its constituents
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListsConstituentsForLists: (lid, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'lid' is not null or undefined
            (0, common_1.assertParamExists)('getListsConstituentsForLists', 'lid', lid);
            const localVarPath = `/lists/{lid}`
                .replace(`{${"lid"}}`, encodeURIComponent(String(lid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Messages for a list and its constituents
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForLists: (lid, type, startDate, endDate, limit, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'lid' is not null or undefined
            (0, common_1.assertParamExists)('getMessagesForLists', 'lid', lid);
            const localVarPath = `/lists/{lid}/messages`
                .replace(`{${"lid"}}`, encodeURIComponent(String(lid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recent messages for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForTitles: (idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'idents' is not null or undefined
            (0, common_1.assertParamExists)('getMessagesForTitles', 'idents', idents);
            const localVarPath = `/titles/{idents}/messages`
                .replace(`{${"idents"}}`, encodeURIComponent(String(idents)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (score !== undefined) {
                localVarQueryParameter['score'] = score;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Run arbitrary search queries against the Stockpulse search index
         * @summary Search in messages
         * @param {string} [query]
         * @param {boolean} [includeTopicsList]
         * @param {boolean} [includeExecSummary]
         * @param {boolean} [includeStats]
         * @param {string} [orderBy]
         * @param {number} [offset]
         * @param {string} [lang]
         * @param {string} [type]
         * @param {string} [source]
         * @param {number} [score]
         * @param {'messages' | 'messages24h'} [core]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchMessages: (query, includeTopicsList, includeExecSummary, includeStats, orderBy, offset, lang, type, source, score, core, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/messages/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (includeTopicsList !== undefined) {
                localVarQueryParameter['include_topics_list'] = includeTopicsList;
            }
            if (includeExecSummary !== undefined) {
                localVarQueryParameter['include_exec_summary'] = includeExecSummary;
            }
            if (includeStats !== undefined) {
                localVarQueryParameter['include_stats'] = includeStats;
            }
            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (score !== undefined) {
                localVarQueryParameter['score'] = score;
            }
            if (core !== undefined) {
                localVarQueryParameter['core'] = core;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides statistics of sources, authors, message types, present entities, etc. for messages in a timespan specified by parameters `startDate` and `endDate`.
         * @summary Statistics about messages for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsForMessages: (idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'idents' is not null or undefined
            (0, common_1.assertParamExists)('getStatisticsForMessages', 'idents', idents);
            const localVarPath = `/titles/{idents}/message_statistics`
                .replace(`{${"idents"}}`, encodeURIComponent(String(idents)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (score !== undefined) {
                localVarQueryParameter['score'] = score;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Technical info for titles, e.g. buzz values and price points
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleInformationForTitles: (idents, vendor, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'idents' is not null or undefined
            (0, common_1.assertParamExists)('getTitleInformationForTitles', 'idents', idents);
            const localVarPath = `/titles/{idents}/info`
                .replace(`{${"idents"}}`, encodeURIComponent(String(idents)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (vendor !== undefined) {
                localVarQueryParameter['vendor'] = vendor;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Run arbitrary search queries against the Stockpulse search index
         * @summary Search in messages
         * @param {SearchSearchMessageRequest} searchSearchMessageRequest Payload in JSON format.
         * @param {'messages' | 'messages24h'} [core]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSearchMessage: (searchSearchMessageRequest, core, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'searchSearchMessageRequest' is not null or undefined
            (0, common_1.assertParamExists)('searchSearchMessage', 'searchSearchMessageRequest', searchSearchMessageRequest);
            const localVarPath = `/messages/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (core !== undefined) {
                localVarQueryParameter['core'] = core;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(searchSearchMessageRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.BuzzSentimentApiAxiosParamCreator = BuzzSentimentApiAxiosParamCreator;
/**
 * BuzzSentimentApi - functional programming interface
 * @export
 */
const BuzzSentimentApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.BuzzSentimentApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Buzz and sentiment for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuzzSentimentForTitles(idents, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBuzzSentimentForTitles(idents, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns tweets grouped by categories of authors. Available author categories: `news`, `analysts`, `traders`, `bloggers`.
         * @summary Messages by author category
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesMessagesForTitles(ident, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCategoriesMessagesForTitles(ident, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary History of buzz and sentiment for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {string} [fields] Comma separated list of additional fields which should be included in the historic data. Available fields (see response definition for meaning of each field): [&#x60;total&#x60;,&#x60;pos&#x60;,&#x60;neg&#x60;,&#x60;smooth_total&#x60;,&#x60;smooth_pos&#x60;,&#x60;smooth_neg&#x60;,&#x60;avg_smooth_total&#x60;,&#x60;avg_smooth_pos&#x60;,&#x60;avg_smooth_neg&#x60;]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricBuzzSentimentForTitles(idents, fields, startDate, endDate, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHistoricBuzzSentimentForTitles(idents, fields, startDate, endDate, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Buzz and sentiment for all lists
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLists(partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLists(partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Buzz and sentiment for a single list and its constituents
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListsConstituentsForLists(lid, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getListsConstituentsForLists(lid, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Messages for a list and its constituents
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForLists(lid, type, startDate, endDate, limit, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessagesForLists(lid, type, startDate, endDate, limit, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recent messages for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForTitles(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessagesForTitles(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Run arbitrary search queries against the Stockpulse search index
         * @summary Search in messages
         * @param {string} [query]
         * @param {boolean} [includeTopicsList]
         * @param {boolean} [includeExecSummary]
         * @param {boolean} [includeStats]
         * @param {string} [orderBy]
         * @param {number} [offset]
         * @param {string} [lang]
         * @param {string} [type]
         * @param {string} [source]
         * @param {number} [score]
         * @param {'messages' | 'messages24h'} [core]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchMessages(query, includeTopicsList, includeExecSummary, includeStats, orderBy, offset, lang, type, source, score, core, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSearchMessages(query, includeTopicsList, includeExecSummary, includeStats, orderBy, offset, lang, type, source, score, core, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Provides statistics of sources, authors, message types, present entities, etc. for messages in a timespan specified by parameters `startDate` and `endDate`.
         * @summary Statistics about messages for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsForMessages(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStatisticsForMessages(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Technical info for titles, e.g. buzz values and price points
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleInformationForTitles(idents, vendor, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTitleInformationForTitles(idents, vendor, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Run arbitrary search queries against the Stockpulse search index
         * @summary Search in messages
         * @param {SearchSearchMessageRequest} searchSearchMessageRequest Payload in JSON format.
         * @param {'messages' | 'messages24h'} [core]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSearchMessage(searchSearchMessageRequest, core, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchSearchMessage(searchSearchMessageRequest, core, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.BuzzSentimentApiFp = BuzzSentimentApiFp;
/**
 * BuzzSentimentApi - factory interface
 * @export
 */
const BuzzSentimentApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.BuzzSentimentApiFp)(configuration);
    return {
        /**
         *
         * @summary Buzz and sentiment for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuzzSentimentForTitles(idents, partition, format, options) {
            return localVarFp.getBuzzSentimentForTitles(idents, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns tweets grouped by categories of authors. Available author categories: `news`, `analysts`, `traders`, `bloggers`.
         * @summary Messages by author category
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesMessagesForTitles(ident, startDate, endDate, format, options) {
            return localVarFp.getCategoriesMessagesForTitles(ident, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary History of buzz and sentiment for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {string} [fields] Comma separated list of additional fields which should be included in the historic data. Available fields (see response definition for meaning of each field): [&#x60;total&#x60;,&#x60;pos&#x60;,&#x60;neg&#x60;,&#x60;smooth_total&#x60;,&#x60;smooth_pos&#x60;,&#x60;smooth_neg&#x60;,&#x60;avg_smooth_total&#x60;,&#x60;avg_smooth_pos&#x60;,&#x60;avg_smooth_neg&#x60;]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricBuzzSentimentForTitles(idents, fields, startDate, endDate, partition, format, options) {
            return localVarFp.getHistoricBuzzSentimentForTitles(idents, fields, startDate, endDate, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Buzz and sentiment for all lists
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLists(partition, format, options) {
            return localVarFp.getLists(partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Buzz and sentiment for a single list and its constituents
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListsConstituentsForLists(lid, partition, format, options) {
            return localVarFp.getListsConstituentsForLists(lid, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Messages for a list and its constituents
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForLists(lid, type, startDate, endDate, limit, partition, format, options) {
            return localVarFp.getMessagesForLists(lid, type, startDate, endDate, limit, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recent messages for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForTitles(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options) {
            return localVarFp.getMessagesForTitles(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Run arbitrary search queries against the Stockpulse search index
         * @summary Search in messages
         * @param {string} [query]
         * @param {boolean} [includeTopicsList]
         * @param {boolean} [includeExecSummary]
         * @param {boolean} [includeStats]
         * @param {string} [orderBy]
         * @param {number} [offset]
         * @param {string} [lang]
         * @param {string} [type]
         * @param {string} [source]
         * @param {number} [score]
         * @param {'messages' | 'messages24h'} [core]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSearchMessages(query, includeTopicsList, includeExecSummary, includeStats, orderBy, offset, lang, type, source, score, core, format, options) {
            return localVarFp.getSearchMessages(query, includeTopicsList, includeExecSummary, includeStats, orderBy, offset, lang, type, source, score, core, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides statistics of sources, authors, message types, present entities, etc. for messages in a timespan specified by parameters `startDate` and `endDate`.
         * @summary Statistics about messages for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatisticsForMessages(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options) {
            return localVarFp.getStatisticsForMessages(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Technical info for titles, e.g. buzz values and price points
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleInformationForTitles(idents, vendor, format, options) {
            return localVarFp.getTitleInformationForTitles(idents, vendor, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Run arbitrary search queries against the Stockpulse search index
         * @summary Search in messages
         * @param {SearchSearchMessageRequest} searchSearchMessageRequest Payload in JSON format.
         * @param {'messages' | 'messages24h'} [core]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSearchMessage(searchSearchMessageRequest, core, format, options) {
            return localVarFp.searchSearchMessage(searchSearchMessageRequest, core, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.BuzzSentimentApiFactory = BuzzSentimentApiFactory;
/**
 * BuzzSentimentApi - object-oriented interface
 * @export
 * @class BuzzSentimentApi
 * @extends {BaseAPI}
 */
class BuzzSentimentApi extends base_1.BaseAPI {
    /**
     *
     * @summary Buzz and sentiment for titles
     * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getBuzzSentimentForTitles(idents, partition, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getBuzzSentimentForTitles(idents, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns tweets grouped by categories of authors. Available author categories: `news`, `analysts`, `traders`, `bloggers`.
     * @summary Messages by author category
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getCategoriesMessagesForTitles(ident, startDate, endDate, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getCategoriesMessagesForTitles(ident, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary History of buzz and sentiment for titles
     * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
     * @param {string} [fields] Comma separated list of additional fields which should be included in the historic data. Available fields (see response definition for meaning of each field): [&#x60;total&#x60;,&#x60;pos&#x60;,&#x60;neg&#x60;,&#x60;smooth_total&#x60;,&#x60;smooth_pos&#x60;,&#x60;smooth_neg&#x60;,&#x60;avg_smooth_total&#x60;,&#x60;avg_smooth_pos&#x60;,&#x60;avg_smooth_neg&#x60;]
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getHistoricBuzzSentimentForTitles(idents, fields, startDate, endDate, partition, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getHistoricBuzzSentimentForTitles(idents, fields, startDate, endDate, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Buzz and sentiment for all lists
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getLists(partition, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getLists(partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Buzz and sentiment for a single list and its constituents
     * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getListsConstituentsForLists(lid, partition, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getListsConstituentsForLists(lid, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Messages for a list and its constituents
     * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
     * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getMessagesForLists(lid, type, startDate, endDate, limit, partition, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getMessagesForLists(lid, type, startDate, endDate, limit, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recent messages for titles
     * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
     * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
     * @param {string} [source] Allows to restrict returned messages to a specific source.
     * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
     * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
     * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getMessagesForTitles(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getMessagesForTitles(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Run arbitrary search queries against the Stockpulse search index
     * @summary Search in messages
     * @param {string} [query]
     * @param {boolean} [includeTopicsList]
     * @param {boolean} [includeExecSummary]
     * @param {boolean} [includeStats]
     * @param {string} [orderBy]
     * @param {number} [offset]
     * @param {string} [lang]
     * @param {string} [type]
     * @param {string} [source]
     * @param {number} [score]
     * @param {'messages' | 'messages24h'} [core]
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getSearchMessages(query, includeTopicsList, includeExecSummary, includeStats, orderBy, offset, lang, type, source, score, core, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getSearchMessages(query, includeTopicsList, includeExecSummary, includeStats, orderBy, offset, lang, type, source, score, core, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides statistics of sources, authors, message types, present entities, etc. for messages in a timespan specified by parameters `startDate` and `endDate`.
     * @summary Statistics about messages for titles
     * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
     * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
     * @param {string} [source] Allows to restrict returned messages to a specific source.
     * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
     * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
     * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getStatisticsForMessages(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getStatisticsForMessages(idents, type, source, lang, score, searchTerm, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Technical info for titles, e.g. buzz values and price points
     * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
     * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    getTitleInformationForTitles(idents, vendor, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).getTitleInformationForTitles(idents, vendor, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Run arbitrary search queries against the Stockpulse search index
     * @summary Search in messages
     * @param {SearchSearchMessageRequest} searchSearchMessageRequest Payload in JSON format.
     * @param {'messages' | 'messages24h'} [core]
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuzzSentimentApi
     */
    searchSearchMessage(searchSearchMessageRequest, core, format, options) {
        return (0, exports.BuzzSentimentApiFp)(this.configuration).searchSearchMessage(searchSearchMessageRequest, core, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.BuzzSentimentApi = BuzzSentimentApi;
/**
 * EntitiesApi - axios parameter creator
 * @export
 */
const EntitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Inventory of available entities
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntities: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/entities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary History of entities present in communication about title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityHistoryMessagesForTitles: (ident, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getEntityHistoryMessagesForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/entities/history`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Latest entities present in communication about title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMessagesForTitles: (ident, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getEntityMessagesForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/entities`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary General information about an entity
         * @param {number} entityId Reference to an entity's identity, the entity ID.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonsV6ForEntities: (entityId, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entityId' is not null or undefined
            (0, common_1.assertParamExists)('getPersonsV6ForEntities', 'entityId', entityId);
            const localVarPath = `/entities/{entity_id}`
                .replace(`{${"entity_id"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.EntitiesApiAxiosParamCreator = EntitiesApiAxiosParamCreator;
/**
 * EntitiesApi - functional programming interface
 * @export
 */
const EntitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.EntitiesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Inventory of available entities
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntities(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEntities(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary History of entities present in communication about title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityHistoryMessagesForTitles(ident, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEntityHistoryMessagesForTitles(ident, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Latest entities present in communication about title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMessagesForTitles(ident, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEntityMessagesForTitles(ident, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary General information about an entity
         * @param {number} entityId Reference to an entity's identity, the entity ID.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonsV6ForEntities(entityId, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPersonsV6ForEntities(entityId, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.EntitiesApiFp = EntitiesApiFp;
/**
 * EntitiesApi - factory interface
 * @export
 */
const EntitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.EntitiesApiFp)(configuration);
    return {
        /**
         *
         * @summary Inventory of available entities
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntities(format, options) {
            return localVarFp.getEntities(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary History of entities present in communication about title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityHistoryMessagesForTitles(ident, startDate, endDate, limit, format, options) {
            return localVarFp.getEntityHistoryMessagesForTitles(ident, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Latest entities present in communication about title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityMessagesForTitles(ident, limit, format, options) {
            return localVarFp.getEntityMessagesForTitles(ident, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary General information about an entity
         * @param {number} entityId Reference to an entity's identity, the entity ID.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonsV6ForEntities(entityId, format, options) {
            return localVarFp.getPersonsV6ForEntities(entityId, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.EntitiesApiFactory = EntitiesApiFactory;
/**
 * EntitiesApi - object-oriented interface
 * @export
 * @class EntitiesApi
 * @extends {BaseAPI}
 */
class EntitiesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Inventory of available entities
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntities(format, options) {
        return (0, exports.EntitiesApiFp)(this.configuration).getEntities(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary History of entities present in communication about title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityHistoryMessagesForTitles(ident, startDate, endDate, limit, format, options) {
        return (0, exports.EntitiesApiFp)(this.configuration).getEntityHistoryMessagesForTitles(ident, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Latest entities present in communication about title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getEntityMessagesForTitles(ident, limit, format, options) {
        return (0, exports.EntitiesApiFp)(this.configuration).getEntityMessagesForTitles(ident, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary General information about an entity
     * @param {number} entityId Reference to an entity's identity, the entity ID.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesApi
     */
    getPersonsV6ForEntities(entityId, format, options) {
        return (0, exports.EntitiesApiFp)(this.configuration).getPersonsV6ForEntities(entityId, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.EntitiesApi = EntitiesApi;
/**
 * FinancialsAdvancedApi - axios parameter creator
 * @export
 */
const FinancialsAdvancedApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Specific Bundesanzeiger report
         * @param {number} fedgazReportId Identifier for a specific Bundesanzeiger report. Report IDs are provided in federal gazette profiles, e.g. from API route &#x60;/titles/{ident}/profiles&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundesanzeigerForFederalGazette: (fedgazReportId, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fedgazReportId' is not null or undefined
            (0, common_1.assertParamExists)('getBundesanzeigerForFederalGazette', 'fedgazReportId', fedgazReportId);
            const localVarPath = `/federal_gazette/{fedgaz_report_id}`
                .replace(`{${"fedgaz_report_id"}}`, encodeURIComponent(String(fedgazReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recent Bundesanzeiger report for a title
         * @param {string} ident Reference to a title's identity. Can be either Stockpulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {boolean} [search] If set to true, will perform an additional name based search if no report is associated with given ident
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundesanzeigerForTitles: (ident, search, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getBundesanzeigerForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/federal_gazette`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns titles having a RSI close to the given value.
         * @summary Titles close to provided value for their relative strength index (RSI)
         * @param {7 | 14 | 25} rsiSpan
         * @param {number} compareValue
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRSIComparison: (rsiSpan, compareValue, type, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rsiSpan' is not null or undefined
            (0, common_1.assertParamExists)('getRSIComparison', 'rsiSpan', rsiSpan);
            // verify required parameter 'compareValue' is not null or undefined
            (0, common_1.assertParamExists)('getRSIComparison', 'compareValue', compareValue);
            const localVarPath = `/titles/rsi/{rsi_span}/{compare_value}`
                .replace(`{${"rsi_span"}}`, encodeURIComponent(String(rsiSpan)))
                .replace(`{${"compare_value"}}`, encodeURIComponent(String(compareValue)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns the best sma for titles in the given span
         * @summary Price based simple moving average (SMA) for titles in the given span
         * @param {50 | 200} smaSpan
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSMAComparison: (smaSpan, type, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'smaSpan' is not null or undefined
            (0, common_1.assertParamExists)('getSMAComparison', 'smaSpan', smaSpan);
            const localVarPath = `/titles/sma/{sma_span}`
                .replace(`{${"sma_span"}}`, encodeURIComponent(String(smaSpan)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Simple moving average data for a single title
         * @summary Price based simple moving average data for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSMADataForTitles: (ident, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getSMADataForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/sma`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return the latest short sales for the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
         * @summary Latest short sales by authority
         * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
         * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
         * @param {string} [date]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortSales: (fca, finra, date, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/titles/short_sales`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (fca !== undefined) {
                localVarQueryParameter['fca'] = fca;
            }
            if (finra !== undefined) {
                localVarQueryParameter['finra'] = finra;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substr(0, 10) :
                    date;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Historic short sales for a title and the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
         * @summary History of short sales for the specified title by authority
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
         * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
         * @param {number} [limit]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortSalesHistoryForTitles: (ident, fca, finra, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getShortSalesHistoryForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/short_sales`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (fca !== undefined) {
                localVarQueryParameter['fca'] = fca;
            }
            if (finra !== undefined) {
                localVarQueryParameter['finra'] = finra;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FinancialsAdvancedApiAxiosParamCreator = FinancialsAdvancedApiAxiosParamCreator;
/**
 * FinancialsAdvancedApi - functional programming interface
 * @export
 */
const FinancialsAdvancedApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FinancialsAdvancedApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Specific Bundesanzeiger report
         * @param {number} fedgazReportId Identifier for a specific Bundesanzeiger report. Report IDs are provided in federal gazette profiles, e.g. from API route &#x60;/titles/{ident}/profiles&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundesanzeigerForFederalGazette(fedgazReportId, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBundesanzeigerForFederalGazette(fedgazReportId, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recent Bundesanzeiger report for a title
         * @param {string} ident Reference to a title's identity. Can be either Stockpulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {boolean} [search] If set to true, will perform an additional name based search if no report is associated with given ident
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundesanzeigerForTitles(ident, search, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBundesanzeigerForTitles(ident, search, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns titles having a RSI close to the given value.
         * @summary Titles close to provided value for their relative strength index (RSI)
         * @param {7 | 14 | 25} rsiSpan
         * @param {number} compareValue
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRSIComparison(rsiSpan, compareValue, type, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRSIComparison(rsiSpan, compareValue, type, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns the best sma for titles in the given span
         * @summary Price based simple moving average (SMA) for titles in the given span
         * @param {50 | 200} smaSpan
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSMAComparison(smaSpan, type, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSMAComparison(smaSpan, type, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Simple moving average data for a single title
         * @summary Price based simple moving average data for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSMADataForTitles(ident, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSMADataForTitles(ident, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Return the latest short sales for the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
         * @summary Latest short sales by authority
         * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
         * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
         * @param {string} [date]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortSales(fca, finra, date, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShortSales(fca, finra, date, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Historic short sales for a title and the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
         * @summary History of short sales for the specified title by authority
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
         * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
         * @param {number} [limit]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortSalesHistoryForTitles(ident, fca, finra, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getShortSalesHistoryForTitles(ident, fca, finra, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FinancialsAdvancedApiFp = FinancialsAdvancedApiFp;
/**
 * FinancialsAdvancedApi - factory interface
 * @export
 */
const FinancialsAdvancedApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FinancialsAdvancedApiFp)(configuration);
    return {
        /**
         *
         * @summary Specific Bundesanzeiger report
         * @param {number} fedgazReportId Identifier for a specific Bundesanzeiger report. Report IDs are provided in federal gazette profiles, e.g. from API route &#x60;/titles/{ident}/profiles&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundesanzeigerForFederalGazette(fedgazReportId, format, options) {
            return localVarFp.getBundesanzeigerForFederalGazette(fedgazReportId, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recent Bundesanzeiger report for a title
         * @param {string} ident Reference to a title's identity. Can be either Stockpulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {boolean} [search] If set to true, will perform an additional name based search if no report is associated with given ident
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBundesanzeigerForTitles(ident, search, format, options) {
            return localVarFp.getBundesanzeigerForTitles(ident, search, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns titles having a RSI close to the given value.
         * @summary Titles close to provided value for their relative strength index (RSI)
         * @param {7 | 14 | 25} rsiSpan
         * @param {number} compareValue
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRSIComparison(rsiSpan, compareValue, type, format, options) {
            return localVarFp.getRSIComparison(rsiSpan, compareValue, type, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the best sma for titles in the given span
         * @summary Price based simple moving average (SMA) for titles in the given span
         * @param {50 | 200} smaSpan
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSMAComparison(smaSpan, type, format, options) {
            return localVarFp.getSMAComparison(smaSpan, type, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Simple moving average data for a single title
         * @summary Price based simple moving average data for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSMADataForTitles(ident, format, options) {
            return localVarFp.getSMADataForTitles(ident, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Return the latest short sales for the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
         * @summary Latest short sales by authority
         * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
         * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
         * @param {string} [date]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortSales(fca, finra, date, format, options) {
            return localVarFp.getShortSales(fca, finra, date, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Historic short sales for a title and the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
         * @summary History of short sales for the specified title by authority
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
         * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
         * @param {number} [limit]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShortSalesHistoryForTitles(ident, fca, finra, limit, format, options) {
            return localVarFp.getShortSalesHistoryForTitles(ident, fca, finra, limit, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FinancialsAdvancedApiFactory = FinancialsAdvancedApiFactory;
/**
 * FinancialsAdvancedApi - object-oriented interface
 * @export
 * @class FinancialsAdvancedApi
 * @extends {BaseAPI}
 */
class FinancialsAdvancedApi extends base_1.BaseAPI {
    /**
     *
     * @summary Specific Bundesanzeiger report
     * @param {number} fedgazReportId Identifier for a specific Bundesanzeiger report. Report IDs are provided in federal gazette profiles, e.g. from API route &#x60;/titles/{ident}/profiles&#x60;.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsAdvancedApi
     */
    getBundesanzeigerForFederalGazette(fedgazReportId, format, options) {
        return (0, exports.FinancialsAdvancedApiFp)(this.configuration).getBundesanzeigerForFederalGazette(fedgazReportId, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recent Bundesanzeiger report for a title
     * @param {string} ident Reference to a title's identity. Can be either Stockpulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {boolean} [search] If set to true, will perform an additional name based search if no report is associated with given ident
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsAdvancedApi
     */
    getBundesanzeigerForTitles(ident, search, format, options) {
        return (0, exports.FinancialsAdvancedApiFp)(this.configuration).getBundesanzeigerForTitles(ident, search, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns titles having a RSI close to the given value.
     * @summary Titles close to provided value for their relative strength index (RSI)
     * @param {7 | 14 | 25} rsiSpan
     * @param {number} compareValue
     * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsAdvancedApi
     */
    getRSIComparison(rsiSpan, compareValue, type, format, options) {
        return (0, exports.FinancialsAdvancedApiFp)(this.configuration).getRSIComparison(rsiSpan, compareValue, type, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns the best sma for titles in the given span
     * @summary Price based simple moving average (SMA) for titles in the given span
     * @param {50 | 200} smaSpan
     * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsAdvancedApi
     */
    getSMAComparison(smaSpan, type, format, options) {
        return (0, exports.FinancialsAdvancedApiFp)(this.configuration).getSMAComparison(smaSpan, type, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Simple moving average data for a single title
     * @summary Price based simple moving average data for a single title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsAdvancedApi
     */
    getSMADataForTitles(ident, format, options) {
        return (0, exports.FinancialsAdvancedApiFp)(this.configuration).getSMADataForTitles(ident, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return the latest short sales for the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
     * @summary Latest short sales by authority
     * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
     * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
     * @param {string} [date]
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsAdvancedApi
     */
    getShortSales(fca, finra, date, format, options) {
        return (0, exports.FinancialsAdvancedApiFp)(this.configuration).getShortSales(fca, finra, date, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Historic short sales for a title and the chosen authority: FINRA (U.S.A.), FCA (U.K.) or Federal Gazette (Germany)
     * @summary History of short sales for the specified title by authority
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {boolean} [fca] Set this to 1 or 'true' if you want to retrieve FCA short data (will take priority over FINRA in case both are set).
     * @param {boolean} [finra] Set this to 1 or 'true' if you want to retrieve FINRA short data.
     * @param {number} [limit]
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsAdvancedApi
     */
    getShortSalesHistoryForTitles(ident, fca, finra, limit, format, options) {
        return (0, exports.FinancialsAdvancedApiFp)(this.configuration).getShortSalesHistoryForTitles(ident, fca, finra, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FinancialsAdvancedApi = FinancialsAdvancedApi;
/**
 * FinancialsBasicApi - axios parameter creator
 * @export
 */
const FinancialsBasicApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns the dividend for the last 5 years for the specific title
         * @summary Dividend info for the last years for a specific title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDividendInfoForTitles: (ident, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getDividendInfoForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/dividend`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Titles which have earnings releases during the next 2 days or in any given time frame
         * @param {string} [country] Three-letter country code of country earnings should be retrieved for.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarningsTitles: (country, startDate, endDate, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/titles/earnings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Return is a map with keys = `Company Name|Sector Name (Country)|Sector Name (Global)`, values = `PriceRatioInfo`
         * @summary Price ratios (e.g. P/E) for a company, its competitors from the same country and worldwide
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceRatioComparisonForTitles: (ident, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getPriceRatioComparisonForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/price_ratios`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FinancialsBasicApiAxiosParamCreator = FinancialsBasicApiAxiosParamCreator;
/**
 * FinancialsBasicApi - functional programming interface
 * @export
 */
const FinancialsBasicApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FinancialsBasicApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns the dividend for the last 5 years for the specific title
         * @summary Dividend info for the last years for a specific title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDividendInfoForTitles(ident, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDividendInfoForTitles(ident, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Titles which have earnings releases during the next 2 days or in any given time frame
         * @param {string} [country] Three-letter country code of country earnings should be retrieved for.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarningsTitles(country, startDate, endDate, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getEarningsTitles(country, startDate, endDate, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Return is a map with keys = `Company Name|Sector Name (Country)|Sector Name (Global)`, values = `PriceRatioInfo`
         * @summary Price ratios (e.g. P/E) for a company, its competitors from the same country and worldwide
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceRatioComparisonForTitles(ident, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPriceRatioComparisonForTitles(ident, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FinancialsBasicApiFp = FinancialsBasicApiFp;
/**
 * FinancialsBasicApi - factory interface
 * @export
 */
const FinancialsBasicApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FinancialsBasicApiFp)(configuration);
    return {
        /**
         * Returns the dividend for the last 5 years for the specific title
         * @summary Dividend info for the last years for a specific title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDividendInfoForTitles(ident, format, options) {
            return localVarFp.getDividendInfoForTitles(ident, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Titles which have earnings releases during the next 2 days or in any given time frame
         * @param {string} [country] Three-letter country code of country earnings should be retrieved for.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEarningsTitles(country, startDate, endDate, partition, format, options) {
            return localVarFp.getEarningsTitles(country, startDate, endDate, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Return is a map with keys = `Company Name|Sector Name (Country)|Sector Name (Global)`, values = `PriceRatioInfo`
         * @summary Price ratios (e.g. P/E) for a company, its competitors from the same country and worldwide
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPriceRatioComparisonForTitles(ident, format, options) {
            return localVarFp.getPriceRatioComparisonForTitles(ident, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FinancialsBasicApiFactory = FinancialsBasicApiFactory;
/**
 * FinancialsBasicApi - object-oriented interface
 * @export
 * @class FinancialsBasicApi
 * @extends {BaseAPI}
 */
class FinancialsBasicApi extends base_1.BaseAPI {
    /**
     * Returns the dividend for the last 5 years for the specific title
     * @summary Dividend info for the last years for a specific title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsBasicApi
     */
    getDividendInfoForTitles(ident, format, options) {
        return (0, exports.FinancialsBasicApiFp)(this.configuration).getDividendInfoForTitles(ident, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Titles which have earnings releases during the next 2 days or in any given time frame
     * @param {string} [country] Three-letter country code of country earnings should be retrieved for.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsBasicApi
     */
    getEarningsTitles(country, startDate, endDate, partition, format, options) {
        return (0, exports.FinancialsBasicApiFp)(this.configuration).getEarningsTitles(country, startDate, endDate, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Return is a map with keys = `Company Name|Sector Name (Country)|Sector Name (Global)`, values = `PriceRatioInfo`
     * @summary Price ratios (e.g. P/E) for a company, its competitors from the same country and worldwide
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinancialsBasicApi
     */
    getPriceRatioComparisonForTitles(ident, format, options) {
        return (0, exports.FinancialsBasicApiFp)(this.configuration).getPriceRatioComparisonForTitles(ident, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FinancialsBasicApi = FinancialsBasicApi;
/**
 * GazetteRecordsApi - axios parameter creator
 * @export
 */
const GazetteRecordsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Recent entries of the commercial register of a country (Handelsregister)
         * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForCommercialRegister: (country, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'country' is not null or undefined
            (0, common_1.assertParamExists)('getForCommercialRegister', 'country', country);
            const localVarPath = `/commercial_register/{country}`
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recent official gazette filings
         * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForOfficialGazette: (country, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'country' is not null or undefined
            (0, common_1.assertParamExists)('getForOfficialGazette', 'country', country);
            const localVarPath = `/official_gazette/{country}`
                .replace(`{${"country"}}`, encodeURIComponent(String(country)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.GazetteRecordsApiAxiosParamCreator = GazetteRecordsApiAxiosParamCreator;
/**
 * GazetteRecordsApi - functional programming interface
 * @export
 */
const GazetteRecordsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.GazetteRecordsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Recent entries of the commercial register of a country (Handelsregister)
         * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForCommercialRegister(country, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getForCommercialRegister(country, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recent official gazette filings
         * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForOfficialGazette(country, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getForOfficialGazette(country, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.GazetteRecordsApiFp = GazetteRecordsApiFp;
/**
 * GazetteRecordsApi - factory interface
 * @export
 */
const GazetteRecordsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.GazetteRecordsApiFp)(configuration);
    return {
        /**
         *
         * @summary Recent entries of the commercial register of a country (Handelsregister)
         * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForCommercialRegister(country, format, options) {
            return localVarFp.getForCommercialRegister(country, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recent official gazette filings
         * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForOfficialGazette(country, format, options) {
            return localVarFp.getForOfficialGazette(country, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.GazetteRecordsApiFactory = GazetteRecordsApiFactory;
/**
 * GazetteRecordsApi - object-oriented interface
 * @export
 * @class GazetteRecordsApi
 * @extends {BaseAPI}
 */
class GazetteRecordsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Recent entries of the commercial register of a country (Handelsregister)
     * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GazetteRecordsApi
     */
    getForCommercialRegister(country, format, options) {
        return (0, exports.GazetteRecordsApiFp)(this.configuration).getForCommercialRegister(country, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recent official gazette filings
     * @param {'DE' | 'DEU' | 'CH' | 'CHE' | 'GB' | 'GBR' | 'UK'} country Two or three-letter country code of country for which filings should be retrieved for. Currently available Germany, Switzerland and United Kingdom.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GazetteRecordsApi
     */
    getForOfficialGazette(country, format, options) {
        return (0, exports.GazetteRecordsApiFp)(this.configuration).getForOfficialGazette(country, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.GazetteRecordsApi = GazetteRecordsApi;
/**
 * InventoryApi - axios parameter creator
 * @export
 */
const InventoryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns a map of filter options with the first level in the map specifying the source, the second the available properties to filter by in the source and the type of the property.
         * @summary Available filter options for unlisted titles
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFilters: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/titles/available_filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Countries with two-letter and three-letter country codes, and continent codes
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Available exchanges
         * @param {string} [country] Three-letter country code to filter exchanges for.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchanges: (country, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/exchanges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Trading holidays
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidays: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/holidays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Titles which are available in subscription
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/inventory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Search for a title by query
         * @param {string} query The search string which is used to lookup titles. Will first try looking for Stockpulse ID or ISIN. If nothing found it will do a fuzzy name search.
         * @param {'name' | 'freetext'} [searchType] Where to search for the provided query. Can bei either in name fields of titles (name search) or in freetext fields of associated sources, e.g. website content, descriptions, etc. (freetext search).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookUpCompany: (query, searchType, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'query' is not null or undefined
            (0, common_1.assertParamExists)('getLookUpCompany', 'query', query);
            const localVarPath = `/titles/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (searchType !== undefined) {
                localVarQueryParameter['search_type'] = searchType;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns related titles to the given title ID divided into sector and region. For listed stocks the most important index will be provided as well. For other title types \'index\' includes the closest related title.
         * @summary Title information for related titles
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Max items returned for region and sector respectively. The internal limit of 10 cannot be exceeded.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedTitlesForTitles: (ident, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getRelatedTitlesForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/related`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides the available `reports` which are calculated based on the incoming buzz. We also refer to reports as `partitions`. Reports are calculated periodically, e.g. the report `10minute` is calculated every full 10 minutes, e.g. at 10:10am. The same is true for `hourly` and all other reports, which are intraday. Daily reports are calculated once a day at certain points in time. E.g. the `daily_5am` report is calculated at 5am (server timezone: Europe/Berlin). More information on reports can be found in this [whitepaper](https://www.stockpulse.de/extracting-alpha-information-from-social-media-sentiment-data/). To retrieve data for a particular report append the query parameter `partition` or `report` to relevant API requests.
         * @summary Reports / partitions
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportModels: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Company sectors, industries, etc.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/sectors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary All existing titles
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
         * @param {number} [sector] Filter by company sector with sector ID. A full inventory of available sectors can be retrieved with the /sectors API endpoint.
         * @param {number} [priExchange] Filter by primary exchange of company with exchange ID, MIC or exchange name. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
         * @param {number} [exchange] Filter by exchange where title is listed at by exchange ID. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
         * @param {number} [list] Filter by list membership, e. g. titles which are members of Dow Jones Industrial Average using the list ID. A full inventory of available lists can be retrieved with the /lists API endpoint.
         * @param {number} [buzz] Filter by current buzz value, e. g. 3 for titles which currently have a buzz of 3 or higher.
         * @param {number} [sentHigher] Filter by current sentiment value, e. g. 5 for titles which currently have a sentiment of +5 or higher.
         * @param {number} [sentLower] Filter by current sentiment value, e. g. -5 for titles which currently have a sentiment of -5 or lower.
         * @param {number} [chgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last trading day's close.
         * @param {number} [chgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last trading day's close.
         * @param {number} [weekChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last week's close.
         * @param {number} [weekChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last week's close.
         * @param {number} [monthChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last month's close.
         * @param {number} [monthChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last month's close.
         * @param {number} [yearChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last year's close.
         * @param {number} [yearChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last year's close.
         * @param {number} [dist52WeekHighHigher] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekHighLower] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekLowHigher] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekLowLower] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {'buzz' | 'buzz_asc' | 'sentiment' | 'sentiment_asc' | 'chg' | 'chg_asc' | 'market_cap' | 'market_cap_asc' | 'market_cap_usd' | 'market_cap_usd_asc'} [sortBy] Sort result by various properties of the returned titles, e.g. buzz or sentiment. Default sort order is descending. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleInventory: (type, region, sector, priExchange, exchange, list, buzz, sentHigher, sentLower, chgHigher, chgLower, weekChgHigher, weekChgLower, monthChgHigher, monthChgLower, yearChgHigher, yearChgLower, dist52WeekHighHigher, dist52WeekHighLower, dist52WeekLowHigher, dist52WeekLowLower, sortBy, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/titles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            if (sector !== undefined) {
                localVarQueryParameter['sector'] = sector;
            }
            if (priExchange !== undefined) {
                localVarQueryParameter['pri_exchange'] = priExchange;
            }
            if (exchange !== undefined) {
                localVarQueryParameter['exchange'] = exchange;
            }
            if (list !== undefined) {
                localVarQueryParameter['list'] = list;
            }
            if (buzz !== undefined) {
                localVarQueryParameter['buzz'] = buzz;
            }
            if (sentHigher !== undefined) {
                localVarQueryParameter['sent_higher'] = sentHigher;
            }
            if (sentLower !== undefined) {
                localVarQueryParameter['sent_lower'] = sentLower;
            }
            if (chgHigher !== undefined) {
                localVarQueryParameter['chg_higher'] = chgHigher;
            }
            if (chgLower !== undefined) {
                localVarQueryParameter['chg_lower'] = chgLower;
            }
            if (weekChgHigher !== undefined) {
                localVarQueryParameter['week_chg_higher'] = weekChgHigher;
            }
            if (weekChgLower !== undefined) {
                localVarQueryParameter['week_chg_lower'] = weekChgLower;
            }
            if (monthChgHigher !== undefined) {
                localVarQueryParameter['month_chg_higher'] = monthChgHigher;
            }
            if (monthChgLower !== undefined) {
                localVarQueryParameter['month_chg_lower'] = monthChgLower;
            }
            if (yearChgHigher !== undefined) {
                localVarQueryParameter['year_chg_higher'] = yearChgHigher;
            }
            if (yearChgLower !== undefined) {
                localVarQueryParameter['year_chg_lower'] = yearChgLower;
            }
            if (dist52WeekHighHigher !== undefined) {
                localVarQueryParameter['dist_52_week_high_higher'] = dist52WeekHighHigher;
            }
            if (dist52WeekHighLower !== undefined) {
                localVarQueryParameter['dist_52_week_high_lower'] = dist52WeekHighLower;
            }
            if (dist52WeekLowHigher !== undefined) {
                localVarQueryParameter['dist_52_week_low_higher'] = dist52WeekLowHigher;
            }
            if (dist52WeekLowLower !== undefined) {
                localVarQueryParameter['dist_52_week_low_lower'] = dist52WeekLowLower;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.InventoryApiAxiosParamCreator = InventoryApiAxiosParamCreator;
/**
 * InventoryApi - functional programming interface
 * @export
 */
const InventoryApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InventoryApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns a map of filter options with the first level in the map specifying the source, the second the available properties to filter by in the source and the type of the property.
         * @summary Available filter options for unlisted titles
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFilters(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAvailableFilters(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Countries with two-letter and three-letter country codes, and continent codes
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCountries(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Available exchanges
         * @param {string} [country] Three-letter country code to filter exchanges for.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchanges(country, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExchanges(country, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Trading holidays
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidays(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHolidays(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Titles which are available in subscription
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getInventory(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Search for a title by query
         * @param {string} query The search string which is used to lookup titles. Will first try looking for Stockpulse ID or ISIN. If nothing found it will do a fuzzy name search.
         * @param {'name' | 'freetext'} [searchType] Where to search for the provided query. Can bei either in name fields of titles (name search) or in freetext fields of associated sources, e.g. website content, descriptions, etc. (freetext search).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookUpCompany(query, searchType, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLookUpCompany(query, searchType, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns related titles to the given title ID divided into sector and region. For listed stocks the most important index will be provided as well. For other title types \'index\' includes the closest related title.
         * @summary Title information for related titles
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Max items returned for region and sector respectively. The internal limit of 10 cannot be exceeded.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedTitlesForTitles(ident, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRelatedTitlesForTitles(ident, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Provides the available `reports` which are calculated based on the incoming buzz. We also refer to reports as `partitions`. Reports are calculated periodically, e.g. the report `10minute` is calculated every full 10 minutes, e.g. at 10:10am. The same is true for `hourly` and all other reports, which are intraday. Daily reports are calculated once a day at certain points in time. E.g. the `daily_5am` report is calculated at 5am (server timezone: Europe/Berlin). More information on reports can be found in this [whitepaper](https://www.stockpulse.de/extracting-alpha-information-from-social-media-sentiment-data/). To retrieve data for a particular report append the query parameter `partition` or `report` to relevant API requests.
         * @summary Reports / partitions
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportModels(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getReportModels(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Company sectors, industries, etc.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSectors(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary All existing titles
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
         * @param {number} [sector] Filter by company sector with sector ID. A full inventory of available sectors can be retrieved with the /sectors API endpoint.
         * @param {number} [priExchange] Filter by primary exchange of company with exchange ID, MIC or exchange name. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
         * @param {number} [exchange] Filter by exchange where title is listed at by exchange ID. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
         * @param {number} [list] Filter by list membership, e. g. titles which are members of Dow Jones Industrial Average using the list ID. A full inventory of available lists can be retrieved with the /lists API endpoint.
         * @param {number} [buzz] Filter by current buzz value, e. g. 3 for titles which currently have a buzz of 3 or higher.
         * @param {number} [sentHigher] Filter by current sentiment value, e. g. 5 for titles which currently have a sentiment of +5 or higher.
         * @param {number} [sentLower] Filter by current sentiment value, e. g. -5 for titles which currently have a sentiment of -5 or lower.
         * @param {number} [chgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last trading day's close.
         * @param {number} [chgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last trading day's close.
         * @param {number} [weekChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last week's close.
         * @param {number} [weekChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last week's close.
         * @param {number} [monthChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last month's close.
         * @param {number} [monthChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last month's close.
         * @param {number} [yearChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last year's close.
         * @param {number} [yearChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last year's close.
         * @param {number} [dist52WeekHighHigher] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekHighLower] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekLowHigher] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekLowLower] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {'buzz' | 'buzz_asc' | 'sentiment' | 'sentiment_asc' | 'chg' | 'chg_asc' | 'market_cap' | 'market_cap_asc' | 'market_cap_usd' | 'market_cap_usd_asc'} [sortBy] Sort result by various properties of the returned titles, e.g. buzz or sentiment. Default sort order is descending. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleInventory(type, region, sector, priExchange, exchange, list, buzz, sentHigher, sentLower, chgHigher, chgLower, weekChgHigher, weekChgLower, monthChgHigher, monthChgLower, yearChgHigher, yearChgLower, dist52WeekHighHigher, dist52WeekHighLower, dist52WeekLowHigher, dist52WeekLowLower, sortBy, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTitleInventory(type, region, sector, priExchange, exchange, list, buzz, sentHigher, sentLower, chgHigher, chgLower, weekChgHigher, weekChgLower, monthChgHigher, monthChgLower, yearChgHigher, yearChgLower, dist52WeekHighHigher, dist52WeekHighLower, dist52WeekLowHigher, dist52WeekLowLower, sortBy, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.InventoryApiFp = InventoryApiFp;
/**
 * InventoryApi - factory interface
 * @export
 */
const InventoryApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InventoryApiFp)(configuration);
    return {
        /**
         * Returns a map of filter options with the first level in the map specifying the source, the second the available properties to filter by in the source and the type of the property.
         * @summary Available filter options for unlisted titles
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableFilters(format, options) {
            return localVarFp.getAvailableFilters(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Countries with two-letter and three-letter country codes, and continent codes
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries(format, options) {
            return localVarFp.getCountries(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Available exchanges
         * @param {string} [country] Three-letter country code to filter exchanges for.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExchanges(country, format, options) {
            return localVarFp.getExchanges(country, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Trading holidays
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHolidays(format, options) {
            return localVarFp.getHolidays(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Titles which are available in subscription
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInventory(format, options) {
            return localVarFp.getInventory(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Search for a title by query
         * @param {string} query The search string which is used to lookup titles. Will first try looking for Stockpulse ID or ISIN. If nothing found it will do a fuzzy name search.
         * @param {'name' | 'freetext'} [searchType] Where to search for the provided query. Can bei either in name fields of titles (name search) or in freetext fields of associated sources, e.g. website content, descriptions, etc. (freetext search).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLookUpCompany(query, searchType, format, options) {
            return localVarFp.getLookUpCompany(query, searchType, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns related titles to the given title ID divided into sector and region. For listed stocks the most important index will be provided as well. For other title types \'index\' includes the closest related title.
         * @summary Title information for related titles
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Max items returned for region and sector respectively. The internal limit of 10 cannot be exceeded.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedTitlesForTitles(ident, limit, format, options) {
            return localVarFp.getRelatedTitlesForTitles(ident, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides the available `reports` which are calculated based on the incoming buzz. We also refer to reports as `partitions`. Reports are calculated periodically, e.g. the report `10minute` is calculated every full 10 minutes, e.g. at 10:10am. The same is true for `hourly` and all other reports, which are intraday. Daily reports are calculated once a day at certain points in time. E.g. the `daily_5am` report is calculated at 5am (server timezone: Europe/Berlin). More information on reports can be found in this [whitepaper](https://www.stockpulse.de/extracting-alpha-information-from-social-media-sentiment-data/). To retrieve data for a particular report append the query parameter `partition` or `report` to relevant API requests.
         * @summary Reports / partitions
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportModels(format, options) {
            return localVarFp.getReportModels(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Company sectors, industries, etc.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectors(format, options) {
            return localVarFp.getSectors(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary All existing titles
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
         * @param {number} [sector] Filter by company sector with sector ID. A full inventory of available sectors can be retrieved with the /sectors API endpoint.
         * @param {number} [priExchange] Filter by primary exchange of company with exchange ID, MIC or exchange name. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
         * @param {number} [exchange] Filter by exchange where title is listed at by exchange ID. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
         * @param {number} [list] Filter by list membership, e. g. titles which are members of Dow Jones Industrial Average using the list ID. A full inventory of available lists can be retrieved with the /lists API endpoint.
         * @param {number} [buzz] Filter by current buzz value, e. g. 3 for titles which currently have a buzz of 3 or higher.
         * @param {number} [sentHigher] Filter by current sentiment value, e. g. 5 for titles which currently have a sentiment of +5 or higher.
         * @param {number} [sentLower] Filter by current sentiment value, e. g. -5 for titles which currently have a sentiment of -5 or lower.
         * @param {number} [chgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last trading day's close.
         * @param {number} [chgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last trading day's close.
         * @param {number} [weekChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last week's close.
         * @param {number} [weekChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last week's close.
         * @param {number} [monthChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last month's close.
         * @param {number} [monthChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last month's close.
         * @param {number} [yearChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last year's close.
         * @param {number} [yearChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last year's close.
         * @param {number} [dist52WeekHighHigher] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekHighLower] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekLowHigher] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {number} [dist52WeekLowLower] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
         * @param {'buzz' | 'buzz_asc' | 'sentiment' | 'sentiment_asc' | 'chg' | 'chg_asc' | 'market_cap' | 'market_cap_asc' | 'market_cap_usd' | 'market_cap_usd_asc'} [sortBy] Sort result by various properties of the returned titles, e.g. buzz or sentiment. Default sort order is descending. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleInventory(type, region, sector, priExchange, exchange, list, buzz, sentHigher, sentLower, chgHigher, chgLower, weekChgHigher, weekChgLower, monthChgHigher, monthChgLower, yearChgHigher, yearChgLower, dist52WeekHighHigher, dist52WeekHighLower, dist52WeekLowHigher, dist52WeekLowLower, sortBy, format, options) {
            return localVarFp.getTitleInventory(type, region, sector, priExchange, exchange, list, buzz, sentHigher, sentLower, chgHigher, chgLower, weekChgHigher, weekChgLower, monthChgHigher, monthChgLower, yearChgHigher, yearChgLower, dist52WeekHighHigher, dist52WeekHighLower, dist52WeekLowHigher, dist52WeekLowLower, sortBy, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.InventoryApiFactory = InventoryApiFactory;
/**
 * InventoryApi - object-oriented interface
 * @export
 * @class InventoryApi
 * @extends {BaseAPI}
 */
class InventoryApi extends base_1.BaseAPI {
    /**
     * Returns a map of filter options with the first level in the map specifying the source, the second the available properties to filter by in the source and the type of the property.
     * @summary Available filter options for unlisted titles
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getAvailableFilters(format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getAvailableFilters(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Countries with two-letter and three-letter country codes, and continent codes
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getCountries(format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getCountries(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Available exchanges
     * @param {string} [country] Three-letter country code to filter exchanges for.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getExchanges(country, format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getExchanges(country, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Trading holidays
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getHolidays(format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getHolidays(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Titles which are available in subscription
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getInventory(format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getInventory(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Search for a title by query
     * @param {string} query The search string which is used to lookup titles. Will first try looking for Stockpulse ID or ISIN. If nothing found it will do a fuzzy name search.
     * @param {'name' | 'freetext'} [searchType] Where to search for the provided query. Can bei either in name fields of titles (name search) or in freetext fields of associated sources, e.g. website content, descriptions, etc. (freetext search).
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getLookUpCompany(query, searchType, format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getLookUpCompany(query, searchType, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns related titles to the given title ID divided into sector and region. For listed stocks the most important index will be provided as well. For other title types \'index\' includes the closest related title.
     * @summary Title information for related titles
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {number} [limit] Max items returned for region and sector respectively. The internal limit of 10 cannot be exceeded.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getRelatedTitlesForTitles(ident, limit, format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getRelatedTitlesForTitles(ident, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides the available `reports` which are calculated based on the incoming buzz. We also refer to reports as `partitions`. Reports are calculated periodically, e.g. the report `10minute` is calculated every full 10 minutes, e.g. at 10:10am. The same is true for `hourly` and all other reports, which are intraday. Daily reports are calculated once a day at certain points in time. E.g. the `daily_5am` report is calculated at 5am (server timezone: Europe/Berlin). More information on reports can be found in this [whitepaper](https://www.stockpulse.de/extracting-alpha-information-from-social-media-sentiment-data/). To retrieve data for a particular report append the query parameter `partition` or `report` to relevant API requests.
     * @summary Reports / partitions
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getReportModels(format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getReportModels(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Company sectors, industries, etc.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getSectors(format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getSectors(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary All existing titles
     * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
     * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
     * @param {number} [sector] Filter by company sector with sector ID. A full inventory of available sectors can be retrieved with the /sectors API endpoint.
     * @param {number} [priExchange] Filter by primary exchange of company with exchange ID, MIC or exchange name. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
     * @param {number} [exchange] Filter by exchange where title is listed at by exchange ID. A full inventory of available exchanges can be retrieved with the /exchanges API endpoint.
     * @param {number} [list] Filter by list membership, e. g. titles which are members of Dow Jones Industrial Average using the list ID. A full inventory of available lists can be retrieved with the /lists API endpoint.
     * @param {number} [buzz] Filter by current buzz value, e. g. 3 for titles which currently have a buzz of 3 or higher.
     * @param {number} [sentHigher] Filter by current sentiment value, e. g. 5 for titles which currently have a sentiment of +5 or higher.
     * @param {number} [sentLower] Filter by current sentiment value, e. g. -5 for titles which currently have a sentiment of -5 or lower.
     * @param {number} [chgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last trading day's close.
     * @param {number} [chgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last trading day's close.
     * @param {number} [weekChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last week's close.
     * @param {number} [weekChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last week's close.
     * @param {number} [monthChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last month's close.
     * @param {number} [monthChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last month's close.
     * @param {number} [yearChgHigher] Filter by price change, e. g. 0.05 for titles which had their price rose +5 percent or more compared to last year's close.
     * @param {number} [yearChgLower] Filter by price change, e. g. -0.05 for titles which had their price fell -5 percent or more compared to last year's close.
     * @param {number} [dist52WeekHighHigher] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
     * @param {number} [dist52WeekHighLower] Filter by current absolute price distance in percent compared to the 52 week high, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
     * @param {number} [dist52WeekLowHigher] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or higher distance compared to the filter value, e.g. 0.1 for 10 percent.
     * @param {number} [dist52WeekLowLower] Filter by current absolute price distance in percent compared to the 52 week low, filter returns titles which have a equal or lower distance compared to the filter value, e.g. 0.1 for 10 percent.
     * @param {'buzz' | 'buzz_asc' | 'sentiment' | 'sentiment_asc' | 'chg' | 'chg_asc' | 'market_cap' | 'market_cap_asc' | 'market_cap_usd' | 'market_cap_usd_asc'} [sortBy] Sort result by various properties of the returned titles, e.g. buzz or sentiment. Default sort order is descending. Ascending sort can be set by appending '_asc' to the property of choice.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InventoryApi
     */
    getTitleInventory(type, region, sector, priExchange, exchange, list, buzz, sentHigher, sentLower, chgHigher, chgLower, weekChgHigher, weekChgLower, monthChgHigher, monthChgLower, yearChgHigher, yearChgLower, dist52WeekHighHigher, dist52WeekHighLower, dist52WeekLowHigher, dist52WeekLowLower, sortBy, format, options) {
        return (0, exports.InventoryApiFp)(this.configuration).getTitleInventory(type, region, sector, priExchange, exchange, list, buzz, sentHigher, sentLower, chgHigher, chgLower, weekChgHigher, weekChgLower, monthChgHigher, monthChgLower, yearChgHigher, yearChgLower, dist52WeekHighHigher, dist52WeekHighLower, dist52WeekLowHigher, dist52WeekLowLower, sortBy, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InventoryApi = InventoryApi;
/**
 * KeyEventsApi - axios parameter creator
 * @export
 */
const KeyEventsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Key event buzz from recent messages
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestKeyEvents: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/key_events/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Tracked key events (earnings, ...)
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedKeyEvents: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/key_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * History options available. Defaults to key event buzz from the last 24 hours.
         * @summary Key events for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleKeyEventsForTitles: (ident, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getTitleKeyEventsForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/key_events`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.KeyEventsApiAxiosParamCreator = KeyEventsApiAxiosParamCreator;
/**
 * KeyEventsApi - functional programming interface
 * @export
 */
const KeyEventsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.KeyEventsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Key event buzz from recent messages
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestKeyEvents(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestKeyEvents(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Tracked key events (earnings, ...)
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedKeyEvents(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPredefinedKeyEvents(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * History options available. Defaults to key event buzz from the last 24 hours.
         * @summary Key events for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleKeyEventsForTitles(ident, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTitleKeyEventsForTitles(ident, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.KeyEventsApiFp = KeyEventsApiFp;
/**
 * KeyEventsApi - factory interface
 * @export
 */
const KeyEventsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.KeyEventsApiFp)(configuration);
    return {
        /**
         *
         * @summary Key event buzz from recent messages
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestKeyEvents(format, options) {
            return localVarFp.getLatestKeyEvents(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Tracked key events (earnings, ...)
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedKeyEvents(format, options) {
            return localVarFp.getPredefinedKeyEvents(format, options).then((request) => request(axios, basePath));
        },
        /**
         * History options available. Defaults to key event buzz from the last 24 hours.
         * @summary Key events for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitleKeyEventsForTitles(ident, startDate, endDate, format, options) {
            return localVarFp.getTitleKeyEventsForTitles(ident, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.KeyEventsApiFactory = KeyEventsApiFactory;
/**
 * KeyEventsApi - object-oriented interface
 * @export
 * @class KeyEventsApi
 * @extends {BaseAPI}
 */
class KeyEventsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Key event buzz from recent messages
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyEventsApi
     */
    getLatestKeyEvents(format, options) {
        return (0, exports.KeyEventsApiFp)(this.configuration).getLatestKeyEvents(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Tracked key events (earnings, ...)
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyEventsApi
     */
    getPredefinedKeyEvents(format, options) {
        return (0, exports.KeyEventsApiFp)(this.configuration).getPredefinedKeyEvents(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * History options available. Defaults to key event buzz from the last 24 hours.
     * @summary Key events for a single title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyEventsApi
     */
    getTitleKeyEventsForTitles(ident, startDate, endDate, format, options) {
        return (0, exports.KeyEventsApiFp)(this.configuration).getTitleKeyEventsForTitles(ident, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.KeyEventsApi = KeyEventsApi;
/**
 * KeyEventsV2Api - axios parameter creator
 * @export
 */
const KeyEventsV2ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Start and end date options available. Defaults to key events v2 from the last seven days.
         * @summary Key events v2 for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyEventsV2ForTitles: (idents, partition, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'idents' is not null or undefined
            (0, common_1.assertParamExists)('getKeyEventsV2ForTitles', 'idents', idents);
            const localVarPath = `/titles/{idents}/key_events_v2`
                .replace(`{${"idents"}}`, encodeURIComponent(String(idents)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve latest message by key event ID. Available key event IDs can be retrieved in route `/key_events_v2`.
         * @summary Messages by key event v2
         * @param {number} keyEventId Reference to a key event (e.g. earnings release or analyst update).
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForKeyEventsV2: (keyEventId, type, startDate, endDate, limit, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'keyEventId' is not null or undefined
            (0, common_1.assertParamExists)('getMessagesForKeyEventsV2', 'keyEventId', keyEventId);
            const localVarPath = `/key_events_v2/{key_event_id}/messages`
                .replace(`{${"key_event_id"}}`, encodeURIComponent(String(keyEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Tracked key events v2 (Earnings Release, Analyst Update, ...)
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedKeyEventsV2: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/key_events_v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Retrieve titles for which a key events, specified by its key event ID, has been detected recently. Available key event IDs can be retrieved in route `/key_events_v2`.
         * @summary Titles which have key event v2
         * @param {number} keyEventId Key event ID for which titles should be returned. Available key event IDs can be retrieved in route &#x60;/key_events_v2&#x60;.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitlesForKeyEvent: (keyEventId, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'keyEventId' is not null or undefined
            (0, common_1.assertParamExists)('getTitlesForKeyEvent', 'keyEventId', keyEventId);
            const localVarPath = `/key_events_v2/{key_event_id}`
                .replace(`{${"key_event_id"}}`, encodeURIComponent(String(keyEventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.KeyEventsV2ApiAxiosParamCreator = KeyEventsV2ApiAxiosParamCreator;
/**
 * KeyEventsV2Api - functional programming interface
 * @export
 */
const KeyEventsV2ApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.KeyEventsV2ApiAxiosParamCreator)(configuration);
    return {
        /**
         * Start and end date options available. Defaults to key events v2 from the last seven days.
         * @summary Key events v2 for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyEventsV2ForTitles(idents, partition, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getKeyEventsV2ForTitles(idents, partition, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve latest message by key event ID. Available key event IDs can be retrieved in route `/key_events_v2`.
         * @summary Messages by key event v2
         * @param {number} keyEventId Reference to a key event (e.g. earnings release or analyst update).
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForKeyEventsV2(keyEventId, type, startDate, endDate, limit, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessagesForKeyEventsV2(keyEventId, type, startDate, endDate, limit, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Tracked key events v2 (Earnings Release, Analyst Update, ...)
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedKeyEventsV2(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPredefinedKeyEventsV2(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Retrieve titles for which a key events, specified by its key event ID, has been detected recently. Available key event IDs can be retrieved in route `/key_events_v2`.
         * @summary Titles which have key event v2
         * @param {number} keyEventId Key event ID for which titles should be returned. Available key event IDs can be retrieved in route &#x60;/key_events_v2&#x60;.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitlesForKeyEvent(keyEventId, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTitlesForKeyEvent(keyEventId, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.KeyEventsV2ApiFp = KeyEventsV2ApiFp;
/**
 * KeyEventsV2Api - factory interface
 * @export
 */
const KeyEventsV2ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.KeyEventsV2ApiFp)(configuration);
    return {
        /**
         * Start and end date options available. Defaults to key events v2 from the last seven days.
         * @summary Key events v2 for titles
         * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getKeyEventsV2ForTitles(idents, partition, startDate, endDate, format, options) {
            return localVarFp.getKeyEventsV2ForTitles(idents, partition, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve latest message by key event ID. Available key event IDs can be retrieved in route `/key_events_v2`.
         * @summary Messages by key event v2
         * @param {number} keyEventId Reference to a key event (e.g. earnings release or analyst update).
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForKeyEventsV2(keyEventId, type, startDate, endDate, limit, partition, format, options) {
            return localVarFp.getMessagesForKeyEventsV2(keyEventId, type, startDate, endDate, limit, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Tracked key events v2 (Earnings Release, Analyst Update, ...)
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPredefinedKeyEventsV2(format, options) {
            return localVarFp.getPredefinedKeyEventsV2(format, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve titles for which a key events, specified by its key event ID, has been detected recently. Available key event IDs can be retrieved in route `/key_events_v2`.
         * @summary Titles which have key event v2
         * @param {number} keyEventId Key event ID for which titles should be returned. Available key event IDs can be retrieved in route &#x60;/key_events_v2&#x60;.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTitlesForKeyEvent(keyEventId, startDate, endDate, format, options) {
            return localVarFp.getTitlesForKeyEvent(keyEventId, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.KeyEventsV2ApiFactory = KeyEventsV2ApiFactory;
/**
 * KeyEventsV2Api - object-oriented interface
 * @export
 * @class KeyEventsV2Api
 * @extends {BaseAPI}
 */
class KeyEventsV2Api extends base_1.BaseAPI {
    /**
     * Start and end date options available. Defaults to key events v2 from the last seven days.
     * @summary Key events v2 for titles
     * @param {string} idents Reference to one or more identifiers of titles. When passing multiple identifiers they have to be separated by comma (see example value). Can be either StockPulse IDs, ISIN codes, Yahoo Finance codes, Bloomberg codes, or currency pairs (e. g. EURUSD). Mixed format is supported, e.g. mixing Stockpulse IDs and ISIN codes. The response format is different for requests using single or multiple identifiers.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyEventsV2Api
     */
    getKeyEventsV2ForTitles(idents, partition, startDate, endDate, format, options) {
        return (0, exports.KeyEventsV2ApiFp)(this.configuration).getKeyEventsV2ForTitles(idents, partition, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve latest message by key event ID. Available key event IDs can be retrieved in route `/key_events_v2`.
     * @summary Messages by key event v2
     * @param {number} keyEventId Reference to a key event (e.g. earnings release or analyst update).
     * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyEventsV2Api
     */
    getMessagesForKeyEventsV2(keyEventId, type, startDate, endDate, limit, partition, format, options) {
        return (0, exports.KeyEventsV2ApiFp)(this.configuration).getMessagesForKeyEventsV2(keyEventId, type, startDate, endDate, limit, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Tracked key events v2 (Earnings Release, Analyst Update, ...)
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyEventsV2Api
     */
    getPredefinedKeyEventsV2(format, options) {
        return (0, exports.KeyEventsV2ApiFp)(this.configuration).getPredefinedKeyEventsV2(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve titles for which a key events, specified by its key event ID, has been detected recently. Available key event IDs can be retrieved in route `/key_events_v2`.
     * @summary Titles which have key event v2
     * @param {number} keyEventId Key event ID for which titles should be returned. Available key event IDs can be retrieved in route &#x60;/key_events_v2&#x60;.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeyEventsV2Api
     */
    getTitlesForKeyEvent(keyEventId, startDate, endDate, format, options) {
        return (0, exports.KeyEventsV2ApiFp)(this.configuration).getTitlesForKeyEvent(keyEventId, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.KeyEventsV2Api = KeyEventsV2Api;
/**
 * NewsbotsApi - axios parameter creator
 * @export
 */
const NewsbotsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Will return the latest 10 standard triggers as RSS.
         * @summary RSS feed for triggers of standard rules
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTriggers: (language, limit, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/triggers/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Individual newsbot article by article_id as RSS
         * @param {string} articleIds Comma separated list of article IDs, also takes single number without comma to retrieve just one article.
         * @param {boolean} [includeData]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForNewsbot: (articleIds, includeData, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'articleIds' is not null or undefined
            (0, common_1.assertParamExists)('getForNewsbot', 'articleIds', articleIds);
            const localVarPath = `/newsbot/{article_ids}`
                .replace(`{${"article_ids"}}`, encodeURIComponent(String(articleIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (includeData !== undefined) {
                localVarQueryParameter['include_data'] = includeData;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Individual newsbot article by ident as RSS
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {boolean} [includeData]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentTitlesNewsbot: (ident, language, includeData, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getIdentTitlesNewsbot', 'ident', ident);
            const localVarPath = `/newsbot/titles/{ident}`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (includeData !== undefined) {
                localVarQueryParameter['include_data'] = includeData;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary RSS with latest newsbot articles
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {boolean} [includeData]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestNewsbot: (language, includeData, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/newsbot/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (includeData !== undefined) {
                localVarQueryParameter['include_data'] = includeData;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Will return message for individual trigger as `RSS`.
         * @summary Article for an individual trigger as RSS
         * @param {number} triggerId
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerIdFeedTriggers: (triggerId, language, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'triggerId' is not null or undefined
            (0, common_1.assertParamExists)('getTriggerIdFeedTriggers', 'triggerId', triggerId);
            const localVarPath = `/triggers/feed/{trigger_id}`
                .replace(`{${"trigger_id"}}`, encodeURIComponent(String(triggerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.NewsbotsApiAxiosParamCreator = NewsbotsApiAxiosParamCreator;
/**
 * NewsbotsApi - functional programming interface
 * @export
 */
const NewsbotsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.NewsbotsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Will return the latest 10 standard triggers as RSS.
         * @summary RSS feed for triggers of standard rules
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTriggers(language, limit, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFeedTriggers(language, limit, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Individual newsbot article by article_id as RSS
         * @param {string} articleIds Comma separated list of article IDs, also takes single number without comma to retrieve just one article.
         * @param {boolean} [includeData]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForNewsbot(articleIds, includeData, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getForNewsbot(articleIds, includeData, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Individual newsbot article by ident as RSS
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {boolean} [includeData]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentTitlesNewsbot(ident, language, includeData, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIdentTitlesNewsbot(ident, language, includeData, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary RSS with latest newsbot articles
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {boolean} [includeData]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestNewsbot(language, includeData, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getLatestNewsbot(language, includeData, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Will return message for individual trigger as `RSS`.
         * @summary Article for an individual trigger as RSS
         * @param {number} triggerId
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerIdFeedTriggers(triggerId, language, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTriggerIdFeedTriggers(triggerId, language, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.NewsbotsApiFp = NewsbotsApiFp;
/**
 * NewsbotsApi - factory interface
 * @export
 */
const NewsbotsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.NewsbotsApiFp)(configuration);
    return {
        /**
         * Will return the latest 10 standard triggers as RSS.
         * @summary RSS feed for triggers of standard rules
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedTriggers(language, limit, startDate, endDate, format, options) {
            return localVarFp.getFeedTriggers(language, limit, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Individual newsbot article by article_id as RSS
         * @param {string} articleIds Comma separated list of article IDs, also takes single number without comma to retrieve just one article.
         * @param {boolean} [includeData]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForNewsbot(articleIds, includeData, format, options) {
            return localVarFp.getForNewsbot(articleIds, includeData, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Individual newsbot article by ident as RSS
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {boolean} [includeData]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIdentTitlesNewsbot(ident, language, includeData, format, options) {
            return localVarFp.getIdentTitlesNewsbot(ident, language, includeData, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary RSS with latest newsbot articles
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {boolean} [includeData]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestNewsbot(language, includeData, limit, format, options) {
            return localVarFp.getLatestNewsbot(language, includeData, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return message for individual trigger as `RSS`.
         * @summary Article for an individual trigger as RSS
         * @param {number} triggerId
         * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggerIdFeedTriggers(triggerId, language, format, options) {
            return localVarFp.getTriggerIdFeedTriggers(triggerId, language, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.NewsbotsApiFactory = NewsbotsApiFactory;
/**
 * NewsbotsApi - object-oriented interface
 * @export
 * @class NewsbotsApi
 * @extends {BaseAPI}
 */
class NewsbotsApi extends base_1.BaseAPI {
    /**
     * Will return the latest 10 standard triggers as RSS.
     * @summary RSS feed for triggers of standard rules
     * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsbotsApi
     */
    getFeedTriggers(language, limit, startDate, endDate, format, options) {
        return (0, exports.NewsbotsApiFp)(this.configuration).getFeedTriggers(language, limit, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Individual newsbot article by article_id as RSS
     * @param {string} articleIds Comma separated list of article IDs, also takes single number without comma to retrieve just one article.
     * @param {boolean} [includeData]
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsbotsApi
     */
    getForNewsbot(articleIds, includeData, format, options) {
        return (0, exports.NewsbotsApiFp)(this.configuration).getForNewsbot(articleIds, includeData, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Individual newsbot article by ident as RSS
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
     * @param {boolean} [includeData]
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsbotsApi
     */
    getIdentTitlesNewsbot(ident, language, includeData, format, options) {
        return (0, exports.NewsbotsApiFp)(this.configuration).getIdentTitlesNewsbot(ident, language, includeData, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary RSS with latest newsbot articles
     * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
     * @param {boolean} [includeData]
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsbotsApi
     */
    getLatestNewsbot(language, includeData, limit, format, options) {
        return (0, exports.NewsbotsApiFp)(this.configuration).getLatestNewsbot(language, includeData, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Will return message for individual trigger as `RSS`.
     * @summary Article for an individual trigger as RSS
     * @param {number} triggerId
     * @param {'en' | 'de' | 'pt' | 'es' | 'ru' | 'fa' | 'zh'} [language]
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is xml.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsbotsApi
     */
    getTriggerIdFeedTriggers(triggerId, language, format, options) {
        return (0, exports.NewsbotsApiFp)(this.configuration).getTriggerIdFeedTriggers(triggerId, language, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.NewsbotsApi = NewsbotsApi;
/**
 * PriceDataApi - axios parameter creator
 * @export
 */
const PriceDataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Intraday quotes for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {Array<'o' | 'h' | 'l' | 'c'>} [dataOptions] Allows to choose which values from open/high/low/close should be returned, indicated as o|h|l|c, e. g. 'oc' return open and close values.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntradayForTitles: (ident, dataOptions, type, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getIntradayForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/intraday`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (dataOptions) {
                localVarQueryParameter['data_options'] = dataOptions;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Daily quotes for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
         * @param {Array<string>} [indicators] Additional technical indicators which should be returned along with the quotes. Should be provided as comma separated list of indicator identifiers and their span as number, e.g. &#x60;sma200&#x60; or &#x60;rsi26&#x60;. Supported indicators: &#x60;rsi&#x60; (Relative Strength Index), &#x60;sma&#x60; (Simple Moving Average), &#x60;ema&#x60; (Exponential Moving Average)
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuotesForTitles: (ident, vendor, indicators, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getQuotesForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/quotes`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (vendor !== undefined) {
                localVarQueryParameter['vendor'] = vendor;
            }
            if (indicators) {
                localVarQueryParameter['indicators'] = indicators;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PriceDataApiAxiosParamCreator = PriceDataApiAxiosParamCreator;
/**
 * PriceDataApi - functional programming interface
 * @export
 */
const PriceDataApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PriceDataApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Intraday quotes for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {Array<'o' | 'h' | 'l' | 'c'>} [dataOptions] Allows to choose which values from open/high/low/close should be returned, indicated as o|h|l|c, e. g. 'oc' return open and close values.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntradayForTitles(ident, dataOptions, type, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getIntradayForTitles(ident, dataOptions, type, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Daily quotes for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
         * @param {Array<string>} [indicators] Additional technical indicators which should be returned along with the quotes. Should be provided as comma separated list of indicator identifiers and their span as number, e.g. &#x60;sma200&#x60; or &#x60;rsi26&#x60;. Supported indicators: &#x60;rsi&#x60; (Relative Strength Index), &#x60;sma&#x60; (Simple Moving Average), &#x60;ema&#x60; (Exponential Moving Average)
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuotesForTitles(ident, vendor, indicators, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getQuotesForTitles(ident, vendor, indicators, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PriceDataApiFp = PriceDataApiFp;
/**
 * PriceDataApi - factory interface
 * @export
 */
const PriceDataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PriceDataApiFp)(configuration);
    return {
        /**
         *
         * @summary Intraday quotes for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {Array<'o' | 'h' | 'l' | 'c'>} [dataOptions] Allows to choose which values from open/high/low/close should be returned, indicated as o|h|l|c, e. g. 'oc' return open and close values.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIntradayForTitles(ident, dataOptions, type, startDate, endDate, limit, format, options) {
            return localVarFp.getIntradayForTitles(ident, dataOptions, type, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Daily quotes for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
         * @param {Array<string>} [indicators] Additional technical indicators which should be returned along with the quotes. Should be provided as comma separated list of indicator identifiers and their span as number, e.g. &#x60;sma200&#x60; or &#x60;rsi26&#x60;. Supported indicators: &#x60;rsi&#x60; (Relative Strength Index), &#x60;sma&#x60; (Simple Moving Average), &#x60;ema&#x60; (Exponential Moving Average)
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getQuotesForTitles(ident, vendor, indicators, startDate, endDate, format, options) {
            return localVarFp.getQuotesForTitles(ident, vendor, indicators, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PriceDataApiFactory = PriceDataApiFactory;
/**
 * PriceDataApi - object-oriented interface
 * @export
 * @class PriceDataApi
 * @extends {BaseAPI}
 */
class PriceDataApi extends base_1.BaseAPI {
    /**
     *
     * @summary Intraday quotes for single title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {Array<'o' | 'h' | 'l' | 'c'>} [dataOptions] Allows to choose which values from open/high/low/close should be returned, indicated as o|h|l|c, e. g. 'oc' return open and close values.
     * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceDataApi
     */
    getIntradayForTitles(ident, dataOptions, type, startDate, endDate, limit, format, options) {
        return (0, exports.PriceDataApiFp)(this.configuration).getIntradayForTitles(ident, dataOptions, type, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Daily quotes for single title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'stockpulse' | 'factset'} [vendor] Sets the source for the requested quotes.
     * @param {Array<string>} [indicators] Additional technical indicators which should be returned along with the quotes. Should be provided as comma separated list of indicator identifiers and their span as number, e.g. &#x60;sma200&#x60; or &#x60;rsi26&#x60;. Supported indicators: &#x60;rsi&#x60; (Relative Strength Index), &#x60;sma&#x60; (Simple Moving Average), &#x60;ema&#x60; (Exponential Moving Average)
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceDataApi
     */
    getQuotesForTitles(ident, vendor, indicators, startDate, endDate, format, options) {
        return (0, exports.PriceDataApiFp)(this.configuration).getQuotesForTitles(ident, vendor, indicators, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PriceDataApi = PriceDataApi;
/**
 * PulsePicksApi - axios parameter creator
 * @export
 */
const PulsePicksApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Performance of previous daily picks
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricDailyPulsePicks: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/dailypicksperformance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Latest pulse picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
         * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
         * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
         * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicks: (region, restrictToIndices, days, filterByStddev, sortBy, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pulsepicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            if (restrictToIndices !== undefined) {
                localVarQueryParameter['restrict_to_indices'] = restrictToIndices;
            }
            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }
            if (filterByStddev !== undefined) {
                localVarQueryParameter['filter_by_stddev'] = filterByStddev;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary History of pulse picks for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicksForTitle: (ident, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getPulsePicksForTitle', 'ident', ident);
            const localVarPath = `/pulsepicks/{ident}`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Performance of previous pulse picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
         * @param {string} [date] A date string of format &#x60;YYYY-MM-DD&#x60;. Server timezone is Europe/Berlin thus the date string provided should be for Europe/Berlin.
         * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
         * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
         * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc' | 'intraday' | 'intraday_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicksPerformance: (region, restrictToIndices, date, days, filterByStddev, sortBy, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pulsepicksperformance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            if (restrictToIndices !== undefined) {
                localVarQueryParameter['restrict_to_indices'] = restrictToIndices;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }
            if (filterByStddev !== undefined) {
                localVarQueryParameter['filter_by_stddev'] = filterByStddev;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sort_by'] = sortBy;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns titles with the highest values of buzz, optionally filtered by region and/or type of title (`company`, `index`, `crypto_currency`, ...).
         * @summary Top buzz titles, current and historic
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {string} [date]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopBuzzTitles: (region, type, date, limit, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/top_buzz_titles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString().substr(0, 10) :
                    date;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Provides a list of trading signals which is updated once per week on Tuesday.
         * @summary Latest weekly picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyPulsePicks: (region, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/weeklypicks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PulsePicksApiAxiosParamCreator = PulsePicksApiAxiosParamCreator;
/**
 * PulsePicksApi - functional programming interface
 * @export
 */
const PulsePicksApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PulsePicksApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Performance of previous daily picks
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricDailyPulsePicks(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHistoricDailyPulsePicks(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Latest pulse picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
         * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
         * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
         * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicks(region, restrictToIndices, days, filterByStddev, sortBy, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPulsePicks(region, restrictToIndices, days, filterByStddev, sortBy, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary History of pulse picks for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicksForTitle(ident, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPulsePicksForTitle(ident, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Performance of previous pulse picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
         * @param {string} [date] A date string of format &#x60;YYYY-MM-DD&#x60;. Server timezone is Europe/Berlin thus the date string provided should be for Europe/Berlin.
         * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
         * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
         * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc' | 'intraday' | 'intraday_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicksPerformance(region, restrictToIndices, date, days, filterByStddev, sortBy, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPulsePicksPerformance(region, restrictToIndices, date, days, filterByStddev, sortBy, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns titles with the highest values of buzz, optionally filtered by region and/or type of title (`company`, `index`, `crypto_currency`, ...).
         * @summary Top buzz titles, current and historic
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {string} [date]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopBuzzTitles(region, type, date, limit, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTopBuzzTitles(region, type, date, limit, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Provides a list of trading signals which is updated once per week on Tuesday.
         * @summary Latest weekly picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyPulsePicks(region, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWeeklyPulsePicks(region, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PulsePicksApiFp = PulsePicksApiFp;
/**
 * PulsePicksApi - factory interface
 * @export
 */
const PulsePicksApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PulsePicksApiFp)(configuration);
    return {
        /**
         *
         * @summary Performance of previous daily picks
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHistoricDailyPulsePicks(format, options) {
            return localVarFp.getHistoricDailyPulsePicks(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Latest pulse picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
         * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
         * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
         * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicks(region, restrictToIndices, days, filterByStddev, sortBy, limit, format, options) {
            return localVarFp.getPulsePicks(region, restrictToIndices, days, filterByStddev, sortBy, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary History of pulse picks for single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicksForTitle(ident, limit, format, options) {
            return localVarFp.getPulsePicksForTitle(ident, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Performance of previous pulse picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
         * @param {string} [date] A date string of format &#x60;YYYY-MM-DD&#x60;. Server timezone is Europe/Berlin thus the date string provided should be for Europe/Berlin.
         * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
         * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
         * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc' | 'intraday' | 'intraday_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPulsePicksPerformance(region, restrictToIndices, date, days, filterByStddev, sortBy, limit, format, options) {
            return localVarFp.getPulsePicksPerformance(region, restrictToIndices, date, days, filterByStddev, sortBy, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns titles with the highest values of buzz, optionally filtered by region and/or type of title (`company`, `index`, `crypto_currency`, ...).
         * @summary Top buzz titles, current and historic
         * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
         * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
         * @param {string} [date]
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopBuzzTitles(region, type, date, limit, partition, format, options) {
            return localVarFp.getTopBuzzTitles(region, type, date, limit, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Provides a list of trading signals which is updated once per week on Tuesday.
         * @summary Latest weekly picks
         * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWeeklyPulsePicks(region, format, options) {
            return localVarFp.getWeeklyPulsePicks(region, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PulsePicksApiFactory = PulsePicksApiFactory;
/**
 * PulsePicksApi - object-oriented interface
 * @export
 * @class PulsePicksApi
 * @extends {BaseAPI}
 */
class PulsePicksApi extends base_1.BaseAPI {
    /**
     *
     * @summary Performance of previous daily picks
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulsePicksApi
     */
    getHistoricDailyPulsePicks(format, options) {
        return (0, exports.PulsePicksApiFp)(this.configuration).getHistoricDailyPulsePicks(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Latest pulse picks
     * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
     * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
     * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
     * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
     * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulsePicksApi
     */
    getPulsePicks(region, restrictToIndices, days, filterByStddev, sortBy, limit, format, options) {
        return (0, exports.PulsePicksApiFp)(this.configuration).getPulsePicks(region, restrictToIndices, days, filterByStddev, sortBy, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary History of pulse picks for single title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulsePicksApi
     */
    getPulsePicksForTitle(ident, limit, format, options) {
        return (0, exports.PulsePicksApiFp)(this.configuration).getPulsePicksForTitle(ident, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Performance of previous pulse picks
     * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
     * @param {'true' | 'false'} [restrictToIndices] Whether result should be filtered to companies which are component of an index or not.
     * @param {string} [date] A date string of format &#x60;YYYY-MM-DD&#x60;. Server timezone is Europe/Berlin thus the date string provided should be for Europe/Berlin.
     * @param {1 | 2 | 3 | 5 | 10 | 20} [days] The lookahead timespan to use. A value of 3 means 'from today's open the close of the day after tomorrow'.
     * @param {'true' | 'false'} [filterByStddev] Whether result should be filtered from signals which have a higher standard deviation than price target.
     * @param {'buzz' | 'buzz_asc' | 'sig' | 'sig_asc' | 'mean' | 'mean_asc' | 'stdv' | 'stdv_asc' | 'intraday' | 'intraday_asc'} [sortBy] Sort result by various properties of the returned items, e.g. &#x60;buzz&#x60; or &#x60;sig&#x60;. Default sort order is descending by significance. Ascending sort can be set by appending '_asc' to the property of choice.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulsePicksApi
     */
    getPulsePicksPerformance(region, restrictToIndices, date, days, filterByStddev, sortBy, limit, format, options) {
        return (0, exports.PulsePicksApiFp)(this.configuration).getPulsePicksPerformance(region, restrictToIndices, date, days, filterByStddev, sortBy, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns titles with the highest values of buzz, optionally filtered by region and/or type of title (`company`, `index`, `crypto_currency`, ...).
     * @summary Top buzz titles, current and historic
     * @param {string} [region] Filter by region with two-letter ISO country code, e.g. &#x60;US&#x60;, &#x60;GB&#x60;, &#x60;HK&#x60;, &#x60;EU&#x60;. Supports continent codes as well (&#x60;EU&#x60;, &#x60;US&#x60;, &#x60;AS&#x60;) and special values &#x60;C&#x60; (crypto currencies) and &#x60;G&#x60; (global instruments such as indices and forex pairs).
     * @param {'company' | 'index' | 'forex' | 'raw_material' | 'derivative' | 'crypto_currency' | 'fund' | 'pre_ipo'} [type] Filter by title type, e.g. &#x60;company&#x60; or &#x60;index&#x60;.
     * @param {string} [date]
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulsePicksApi
     */
    getTopBuzzTitles(region, type, date, limit, partition, format, options) {
        return (0, exports.PulsePicksApiFp)(this.configuration).getTopBuzzTitles(region, type, date, limit, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Provides a list of trading signals which is updated once per week on Tuesday.
     * @summary Latest weekly picks
     * @param {string} [region] Filter by region with two-letter ISO country code, e. g. US, GB, HK, EU.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulsePicksApi
     */
    getWeeklyPulsePicks(region, format, options) {
        return (0, exports.PulsePicksApiFp)(this.configuration).getWeeklyPulsePicks(region, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PulsePicksApi = PulsePicksApi;
/**
 * PulseRatingsApi - axios parameter creator
 * @export
 */
const PulseRatingsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Current ratings for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingForTitle: (ident, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getRatingForTitle', 'ident', ident);
            const localVarPath = `/titles/{ident}/ratings`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary History of ratings for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingHistoryForTitle: (ident, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getRatingHistoryForTitle', 'ident', ident);
            const localVarPath = `/titles/{ident}/ratings/history`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.PulseRatingsApiAxiosParamCreator = PulseRatingsApiAxiosParamCreator;
/**
 * PulseRatingsApi - functional programming interface
 * @export
 */
const PulseRatingsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.PulseRatingsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Current ratings for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingForTitle(ident, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRatingForTitle(ident, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary History of ratings for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingHistoryForTitle(ident, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRatingHistoryForTitle(ident, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.PulseRatingsApiFp = PulseRatingsApiFp;
/**
 * PulseRatingsApi - factory interface
 * @export
 */
const PulseRatingsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.PulseRatingsApiFp)(configuration);
    return {
        /**
         *
         * @summary Current ratings for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingForTitle(ident, format, options) {
            return localVarFp.getRatingForTitle(ident, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary History of ratings for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRatingHistoryForTitle(ident, startDate, endDate, format, options) {
            return localVarFp.getRatingHistoryForTitle(ident, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.PulseRatingsApiFactory = PulseRatingsApiFactory;
/**
 * PulseRatingsApi - object-oriented interface
 * @export
 * @class PulseRatingsApi
 * @extends {BaseAPI}
 */
class PulseRatingsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Current ratings for a title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulseRatingsApi
     */
    getRatingForTitle(ident, format, options) {
        return (0, exports.PulseRatingsApiFp)(this.configuration).getRatingForTitle(ident, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary History of ratings for a title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PulseRatingsApi
     */
    getRatingHistoryForTitle(ident, startDate, endDate, format, options) {
        return (0, exports.PulseRatingsApiFp)(this.configuration).getRatingHistoryForTitle(ident, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.PulseRatingsApi = PulseRatingsApi;
/**
 * RulesApi - axios parameter creator
 * @export
 */
const RulesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Returns the ID of the new rule on successful creation.
         * @summary Add a signal rule
         * @param {Rule} rule Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRule: (rule, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rule' is not null or undefined
            (0, common_1.assertParamExists)('addRule', 'rule', rule);
            const localVarPath = `/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rule, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recent triggers for specific title from active rules of user
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForTriggers: (ident, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getForTriggers', 'ident', ident);
            const localVarPath = `/triggers/{ident}`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary User specific rules
         * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules: (ruleType, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ruleType !== undefined) {
                localVarQueryParameter['rule_type'] = ruleType;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recent triggers from active rules of user
         * @param {number} [ruleId] Specifies the id of the rule for which triggers should be returned. If not set any trigger will be returned. Rule ids can be retrieved by route /rules.
         * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggers: (ruleId, ruleType, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/triggers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (ruleId !== undefined) {
                localVarQueryParameter['rule_id'] = ruleId;
            }
            if (ruleType !== undefined) {
                localVarQueryParameter['rule_type'] = ruleType;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Remove a signal rule
         * @param {number} rid Rule ID as provided from endpoint /rules.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRule: (rid, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rid' is not null or undefined
            (0, common_1.assertParamExists)('removeRule', 'rid', rid);
            const localVarPath = `/rules/{rid}`
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns an updated rule ID on successful execution.
         * @summary Update a signal rule
         * @param {number} rid Rule ID as provided from endpoint /rules.
         * @param {Rule} rule Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemRule: (rid, rule, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rid' is not null or undefined
            (0, common_1.assertParamExists)('updateItemRule', 'rid', rid);
            // verify required parameter 'rule' is not null or undefined
            (0, common_1.assertParamExists)('updateItemRule', 'rule', rule);
            const localVarPath = `/rules/{rid}`
                .replace(`{${"rid"}}`, encodeURIComponent(String(rid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rule, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.RulesApiAxiosParamCreator = RulesApiAxiosParamCreator;
/**
 * RulesApi - functional programming interface
 * @export
 */
const RulesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.RulesApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns the ID of the new rule on successful creation.
         * @summary Add a signal rule
         * @param {Rule} rule Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRule(rule, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addRule(rule, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recent triggers for specific title from active rules of user
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForTriggers(ident, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getForTriggers(ident, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary User specific rules
         * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules(ruleType, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRules(ruleType, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recent triggers from active rules of user
         * @param {number} [ruleId] Specifies the id of the rule for which triggers should be returned. If not set any trigger will be returned. Rule ids can be retrieved by route /rules.
         * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggers(ruleId, ruleType, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTriggers(ruleId, ruleType, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Remove a signal rule
         * @param {number} rid Rule ID as provided from endpoint /rules.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRule(rid, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeRule(rid, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns an updated rule ID on successful execution.
         * @summary Update a signal rule
         * @param {number} rid Rule ID as provided from endpoint /rules.
         * @param {Rule} rule Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemRule(rid, rule, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateItemRule(rid, rule, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.RulesApiFp = RulesApiFp;
/**
 * RulesApi - factory interface
 * @export
 */
const RulesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.RulesApiFp)(configuration);
    return {
        /**
         * Returns the ID of the new rule on successful creation.
         * @summary Add a signal rule
         * @param {Rule} rule Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRule(rule, format, options) {
            return localVarFp.addRule(rule, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recent triggers for specific title from active rules of user
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForTriggers(ident, startDate, endDate, limit, format, options) {
            return localVarFp.getForTriggers(ident, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary User specific rules
         * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRules(ruleType, format, options) {
            return localVarFp.getRules(ruleType, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recent triggers from active rules of user
         * @param {number} [ruleId] Specifies the id of the rule for which triggers should be returned. If not set any trigger will be returned. Rule ids can be retrieved by route /rules.
         * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTriggers(ruleId, ruleType, startDate, endDate, limit, format, options) {
            return localVarFp.getTriggers(ruleId, ruleType, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Remove a signal rule
         * @param {number} rid Rule ID as provided from endpoint /rules.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeRule(rid, format, options) {
            return localVarFp.removeRule(rid, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an updated rule ID on successful execution.
         * @summary Update a signal rule
         * @param {number} rid Rule ID as provided from endpoint /rules.
         * @param {Rule} rule Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateItemRule(rid, rule, format, options) {
            return localVarFp.updateItemRule(rid, rule, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.RulesApiFactory = RulesApiFactory;
/**
 * RulesApi - object-oriented interface
 * @export
 * @class RulesApi
 * @extends {BaseAPI}
 */
class RulesApi extends base_1.BaseAPI {
    /**
     * Returns the ID of the new rule on successful creation.
     * @summary Add a signal rule
     * @param {Rule} rule Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    addRule(rule, format, options) {
        return (0, exports.RulesApiFp)(this.configuration).addRule(rule, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recent triggers for specific title from active rules of user
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    getForTriggers(ident, startDate, endDate, limit, format, options) {
        return (0, exports.RulesApiFp)(this.configuration).getForTriggers(ident, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary User specific rules
     * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    getRules(ruleType, format, options) {
        return (0, exports.RulesApiFp)(this.configuration).getRules(ruleType, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recent triggers from active rules of user
     * @param {number} [ruleId] Specifies the id of the rule for which triggers should be returned. If not set any trigger will be returned. Rule ids can be retrieved by route /rules.
     * @param {'buzz_patterns' | 'user_messages' | 'unlisted_filter'} [ruleType] Specifies the type of rule which should be returned. If not set all rules will be returned.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    getTriggers(ruleId, ruleType, startDate, endDate, limit, format, options) {
        return (0, exports.RulesApiFp)(this.configuration).getTriggers(ruleId, ruleType, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Remove a signal rule
     * @param {number} rid Rule ID as provided from endpoint /rules.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    removeRule(rid, format, options) {
        return (0, exports.RulesApiFp)(this.configuration).removeRule(rid, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns an updated rule ID on successful execution.
     * @summary Update a signal rule
     * @param {number} rid Rule ID as provided from endpoint /rules.
     * @param {Rule} rule Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RulesApi
     */
    updateItemRule(rid, rule, format, options) {
        return (0, exports.RulesApiFp)(this.configuration).updateItemRule(rid, rule, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.RulesApi = RulesApi;
/**
 * SpecialSourcesApi - axios parameter creator
 * @export
 */
const SpecialSourcesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Profile data from social media and other sources for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProfilesForTitles: (ident, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getCompanyProfilesForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/profiles`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Returns a daily aggregate of discord messages per title, created daily at 5am Europe/Berlin. Start and end date options available. Defaults to discord reports from yesterday.
         * @summary Discord Reports
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscordReports: (startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/reports/discord`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Job openings on various platforms
         * @param {'monster' | 'indeed'} source The webpage to get open jobs from, e.g. Indeed or Monster.
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenJobsForJobsInSource: (source, ident, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'source' is not null or undefined
            (0, common_1.assertParamExists)('getOpenJobsForJobsInSource', 'source', source);
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getOpenJobsForJobsInSource', 'ident', ident);
            const localVarPath = `/jobs/{source}/{ident}`
                .replace(`{${"source"}}`, encodeURIComponent(String(source)))
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Discord comments
         * @param {string} server Discord server name or server ID for which comments should be retrieved.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServerCommentsDiscord: (server, startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'server' is not null or undefined
            (0, common_1.assertParamExists)('getServerCommentsDiscord', 'server', server);
            const localVarPath = `/discord/comments/{server}`
                .replace(`{${"server"}}`, encodeURIComponent(String(server)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.SpecialSourcesApiAxiosParamCreator = SpecialSourcesApiAxiosParamCreator;
/**
 * SpecialSourcesApi - functional programming interface
 * @export
 */
const SpecialSourcesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SpecialSourcesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Profile data from social media and other sources for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProfilesForTitles(ident, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanyProfilesForTitles(ident, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Returns a daily aggregate of discord messages per title, created daily at 5am Europe/Berlin. Start and end date options available. Defaults to discord reports from yesterday.
         * @summary Discord Reports
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscordReports(startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getDiscordReports(startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Job openings on various platforms
         * @param {'monster' | 'indeed'} source The webpage to get open jobs from, e.g. Indeed or Monster.
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenJobsForJobsInSource(source, ident, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getOpenJobsForJobsInSource(source, ident, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Discord comments
         * @param {string} server Discord server name or server ID for which comments should be retrieved.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServerCommentsDiscord(server, startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getServerCommentsDiscord(server, startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.SpecialSourcesApiFp = SpecialSourcesApiFp;
/**
 * SpecialSourcesApi - factory interface
 * @export
 */
const SpecialSourcesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SpecialSourcesApiFp)(configuration);
    return {
        /**
         *
         * @summary Profile data from social media and other sources for a single title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyProfilesForTitles(ident, format, options) {
            return localVarFp.getCompanyProfilesForTitles(ident, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a daily aggregate of discord messages per title, created daily at 5am Europe/Berlin. Start and end date options available. Defaults to discord reports from yesterday.
         * @summary Discord Reports
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDiscordReports(startDate, endDate, limit, format, options) {
            return localVarFp.getDiscordReports(startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Job openings on various platforms
         * @param {'monster' | 'indeed'} source The webpage to get open jobs from, e.g. Indeed or Monster.
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOpenJobsForJobsInSource(source, ident, startDate, endDate, format, options) {
            return localVarFp.getOpenJobsForJobsInSource(source, ident, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Discord comments
         * @param {string} server Discord server name or server ID for which comments should be retrieved.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServerCommentsDiscord(server, startDate, endDate, limit, format, options) {
            return localVarFp.getServerCommentsDiscord(server, startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SpecialSourcesApiFactory = SpecialSourcesApiFactory;
/**
 * SpecialSourcesApi - object-oriented interface
 * @export
 * @class SpecialSourcesApi
 * @extends {BaseAPI}
 */
class SpecialSourcesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Profile data from social media and other sources for a single title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialSourcesApi
     */
    getCompanyProfilesForTitles(ident, format, options) {
        return (0, exports.SpecialSourcesApiFp)(this.configuration).getCompanyProfilesForTitles(ident, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Returns a daily aggregate of discord messages per title, created daily at 5am Europe/Berlin. Start and end date options available. Defaults to discord reports from yesterday.
     * @summary Discord Reports
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialSourcesApi
     */
    getDiscordReports(startDate, endDate, limit, format, options) {
        return (0, exports.SpecialSourcesApiFp)(this.configuration).getDiscordReports(startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Job openings on various platforms
     * @param {'monster' | 'indeed'} source The webpage to get open jobs from, e.g. Indeed or Monster.
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialSourcesApi
     */
    getOpenJobsForJobsInSource(source, ident, startDate, endDate, format, options) {
        return (0, exports.SpecialSourcesApiFp)(this.configuration).getOpenJobsForJobsInSource(source, ident, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Discord comments
     * @param {string} server Discord server name or server ID for which comments should be retrieved.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpecialSourcesApi
     */
    getServerCommentsDiscord(server, startDate, endDate, limit, format, options) {
        return (0, exports.SpecialSourcesApiFp)(this.configuration).getServerCommentsDiscord(server, startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SpecialSourcesApi = SpecialSourcesApi;
/**
 * TopicsApi - axios parameter creator
 * @export
 */
const TopicsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Recent topics from tweets for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsForTitles: (ident, startDate, endDate, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('getTopicsForTitles', 'ident', ident);
            const localVarPath = `/titles/{ident}/topics`
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TopicsApiAxiosParamCreator = TopicsApiAxiosParamCreator;
/**
 * TopicsApi - functional programming interface
 * @export
 */
const TopicsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TopicsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Recent topics from tweets for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsForTitles(ident, startDate, endDate, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTopicsForTitles(ident, startDate, endDate, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TopicsApiFp = TopicsApiFp;
/**
 * TopicsApi - factory interface
 * @export
 */
const TopicsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TopicsApiFp)(configuration);
    return {
        /**
         *
         * @summary Recent topics from tweets for a title
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicsForTitles(ident, startDate, endDate, format, options) {
            return localVarFp.getTopicsForTitles(ident, startDate, endDate, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TopicsApiFactory = TopicsApiFactory;
/**
 * TopicsApi - object-oriented interface
 * @export
 * @class TopicsApi
 * @extends {BaseAPI}
 */
class TopicsApi extends base_1.BaseAPI {
    /**
     *
     * @summary Recent topics from tweets for a title
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    getTopicsForTitles(ident, startDate, endDate, format, options) {
        return (0, exports.TopicsApiFp)(this.configuration).getTopicsForTitles(ident, startDate, endDate, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TopicsApi = TopicsApi;
/**
 * TopsFlopsApi - axios parameter creator
 * @export
 */
const TopsFlopsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Will return the tops and flops for given fields, e.g. when using the default, `chg`, it will return the three titles having the highest values for `chg` (tops) and the three with the lowest (flops).
         * @summary Top and flop titles from a index
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'chg' | 'buzz.{report_model_id}' | 'sentiment.{report_model_id}' | 'week_chg' | 'month_chg' | 'year_chg' | 'price_earnings_ratio' | 'price_book_ratio' | 'price_sales_ratio'} [field] Set the evaluated property for which tops and flops are filtered
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopsFlopsForLists: (lid, field, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'lid' is not null or undefined
            (0, common_1.assertParamExists)('getTopsFlopsForLists', 'lid', lid);
            const localVarPath = `/lists/{lid}/top_flop`
                .replace(`{${"lid"}}`, encodeURIComponent(String(lid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (field !== undefined) {
                localVarQueryParameter['field'] = field;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TopsFlopsApiAxiosParamCreator = TopsFlopsApiAxiosParamCreator;
/**
 * TopsFlopsApi - functional programming interface
 * @export
 */
const TopsFlopsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TopsFlopsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Will return the tops and flops for given fields, e.g. when using the default, `chg`, it will return the three titles having the highest values for `chg` (tops) and the three with the lowest (flops).
         * @summary Top and flop titles from a index
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'chg' | 'buzz.{report_model_id}' | 'sentiment.{report_model_id}' | 'week_chg' | 'month_chg' | 'year_chg' | 'price_earnings_ratio' | 'price_book_ratio' | 'price_sales_ratio'} [field] Set the evaluated property for which tops and flops are filtered
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopsFlopsForLists(lid, field, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getTopsFlopsForLists(lid, field, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TopsFlopsApiFp = TopsFlopsApiFp;
/**
 * TopsFlopsApi - factory interface
 * @export
 */
const TopsFlopsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TopsFlopsApiFp)(configuration);
    return {
        /**
         * Will return the tops and flops for given fields, e.g. when using the default, `chg`, it will return the three titles having the highest values for `chg` (tops) and the three with the lowest (flops).
         * @summary Top and flop titles from a index
         * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
         * @param {'chg' | 'buzz.{report_model_id}' | 'sentiment.{report_model_id}' | 'week_chg' | 'month_chg' | 'year_chg' | 'price_earnings_ratio' | 'price_book_ratio' | 'price_sales_ratio'} [field] Set the evaluated property for which tops and flops are filtered
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopsFlopsForLists(lid, field, format, options) {
            return localVarFp.getTopsFlopsForLists(lid, field, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TopsFlopsApiFactory = TopsFlopsApiFactory;
/**
 * TopsFlopsApi - object-oriented interface
 * @export
 * @class TopsFlopsApi
 * @extends {BaseAPI}
 */
class TopsFlopsApi extends base_1.BaseAPI {
    /**
     * Will return the tops and flops for given fields, e.g. when using the default, `chg`, it will return the three titles having the highest values for `chg` (tops) and the three with the lowest (flops).
     * @summary Top and flop titles from a index
     * @param {number} lid Reference to a list's identity, the list ID. It can be retrieved by using the '/lists' endpoint.
     * @param {'chg' | 'buzz.{report_model_id}' | 'sentiment.{report_model_id}' | 'week_chg' | 'month_chg' | 'year_chg' | 'price_earnings_ratio' | 'price_book_ratio' | 'price_sales_ratio'} [field] Set the evaluated property for which tops and flops are filtered
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopsFlopsApi
     */
    getTopsFlopsForLists(lid, field, format, options) {
        return (0, exports.TopsFlopsApiFp)(this.configuration).getTopsFlopsForLists(lid, field, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TopsFlopsApi = TopsFlopsApi;
/**
 * TradingOpportunitiesApi - axios parameter creator
 * @export
 */
const TradingOpportunitiesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Standard rules which trigger trading opportunities
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardRules: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/standard_rules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recent triggers from standard rules
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardTriggers: (startDate, endDate, limit, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/standard_triggers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.TradingOpportunitiesApiAxiosParamCreator = TradingOpportunitiesApiAxiosParamCreator;
/**
 * TradingOpportunitiesApi - functional programming interface
 * @export
 */
const TradingOpportunitiesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.TradingOpportunitiesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Standard rules which trigger trading opportunities
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardRules(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStandardRules(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recent triggers from standard rules
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardTriggers(startDate, endDate, limit, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getStandardTriggers(startDate, endDate, limit, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.TradingOpportunitiesApiFp = TradingOpportunitiesApiFp;
/**
 * TradingOpportunitiesApi - factory interface
 * @export
 */
const TradingOpportunitiesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.TradingOpportunitiesApiFp)(configuration);
    return {
        /**
         *
         * @summary Standard rules which trigger trading opportunities
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardRules(format, options) {
            return localVarFp.getStandardRules(format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recent triggers from standard rules
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStandardTriggers(startDate, endDate, limit, format, options) {
            return localVarFp.getStandardTriggers(startDate, endDate, limit, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.TradingOpportunitiesApiFactory = TradingOpportunitiesApiFactory;
/**
 * TradingOpportunitiesApi - object-oriented interface
 * @export
 * @class TradingOpportunitiesApi
 * @extends {BaseAPI}
 */
class TradingOpportunitiesApi extends base_1.BaseAPI {
    /**
     *
     * @summary Standard rules which trigger trading opportunities
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradingOpportunitiesApi
     */
    getStandardRules(format, options) {
        return (0, exports.TradingOpportunitiesApiFp)(this.configuration).getStandardRules(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recent triggers from standard rules
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TradingOpportunitiesApi
     */
    getStandardTriggers(startDate, endDate, limit, format, options) {
        return (0, exports.TradingOpportunitiesApiFp)(this.configuration).getStandardTriggers(startDate, endDate, limit, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.TradingOpportunitiesApi = TradingOpportunitiesApi;
/**
 * UserdataApi - axios parameter creator
 * @export
 */
const UserdataApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Change data for one or more fields of an user
         * @param {ChangeUserdataRequest} changeUserdataRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserdata: (changeUserdataRequest, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'changeUserdataRequest' is not null or undefined
            (0, common_1.assertParamExists)('changeUserdata', 'changeUserdataRequest', changeUserdataRequest);
            const localVarPath = `/userdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changeUserdataRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Properties of authenticated user\'s account
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserdata: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/userdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.UserdataApiAxiosParamCreator = UserdataApiAxiosParamCreator;
/**
 * UserdataApi - functional programming interface
 * @export
 */
const UserdataApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.UserdataApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Change data for one or more fields of an user
         * @param {ChangeUserdataRequest} changeUserdataRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserdata(changeUserdataRequest, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.changeUserdata(changeUserdataRequest, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Properties of authenticated user\'s account
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserdata(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserdata(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.UserdataApiFp = UserdataApiFp;
/**
 * UserdataApi - factory interface
 * @export
 */
const UserdataApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.UserdataApiFp)(configuration);
    return {
        /**
         *
         * @summary Change data for one or more fields of an user
         * @param {ChangeUserdataRequest} changeUserdataRequest Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeUserdata(changeUserdataRequest, format, options) {
            return localVarFp.changeUserdata(changeUserdataRequest, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Properties of authenticated user\'s account
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserdata(format, options) {
            return localVarFp.getUserdata(format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.UserdataApiFactory = UserdataApiFactory;
/**
 * UserdataApi - object-oriented interface
 * @export
 * @class UserdataApi
 * @extends {BaseAPI}
 */
class UserdataApi extends base_1.BaseAPI {
    /**
     *
     * @summary Change data for one or more fields of an user
     * @param {ChangeUserdataRequest} changeUserdataRequest Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserdataApi
     */
    changeUserdata(changeUserdataRequest, format, options) {
        return (0, exports.UserdataApiFp)(this.configuration).changeUserdata(changeUserdataRequest, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Properties of authenticated user\'s account
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserdataApi
     */
    getUserdata(format, options) {
        return (0, exports.UserdataApiFp)(this.configuration).getUserdata(format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.UserdataApi = UserdataApi;
/**
 * WatchlistsApi - axios parameter creator
 * @export
 */
const WatchlistsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Will return new content of watchlist on success. Either one of the properties `titles`, `authors`, or `queries` is required in payload json. Path parameter `wid` specifies the watchlist, to which items are to be added.
         * @summary Add one or more items to a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistItemsToAdd} watchlistItemsToAdd Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemWatchlist: (wid, watchlistItemsToAdd, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wid' is not null or undefined
            (0, common_1.assertParamExists)('addItemWatchlist', 'wid', wid);
            // verify required parameter 'watchlistItemsToAdd' is not null or undefined
            (0, common_1.assertParamExists)('addItemWatchlist', 'watchlistItemsToAdd', watchlistItemsToAdd);
            const localVarPath = `/watchlists/{wid}`
                .replace(`{${"wid"}}`, encodeURIComponent(String(wid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(watchlistItemsToAdd, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Will return the new Watchlist ID on success.
         * @summary Add a new watchlist
         * @param {WatchlistCreation} watchlistCreation Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWatchlist: (watchlistCreation, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'watchlistCreation' is not null or undefined
            (0, common_1.assertParamExists)('addWatchlist', 'watchlistCreation', watchlistCreation);
            const localVarPath = `/watchlists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(watchlistCreation, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recent messages for all titles in a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForWatchlists: (wid, type, source, lang, score, searchTerm, startDate, endDate, limit, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wid' is not null or undefined
            (0, common_1.assertParamExists)('getMessagesForWatchlists', 'wid', wid);
            const localVarPath = `/watchlists/{wid}/messages`
                .replace(`{${"wid"}}`, encodeURIComponent(String(wid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }
            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (score !== undefined) {
                localVarQueryParameter['score'] = score;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['search_term'] = searchTerm;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Buzz and sentiment for all titles in watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistContentForWatchlists: (wid, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wid' is not null or undefined
            (0, common_1.assertParamExists)('getWatchlistContentForWatchlists', 'wid', wid);
            const localVarPath = `/watchlists/{wid}`
                .replace(`{${"wid"}}`, encodeURIComponent(String(wid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieve existing watchlists
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistsInventory: (format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/watchlists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Removes the specified authors from the list and will return the new content of the watchlist on success.
         * @summary Remove authors from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistAuthorsToRemove} watchlistAuthorsToRemove Payload in JSON format.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAuthorsFromWatchlist: (wid, watchlistAuthorsToRemove, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wid' is not null or undefined
            (0, common_1.assertParamExists)('removeAuthorsFromWatchlist', 'wid', wid);
            // verify required parameter 'watchlistAuthorsToRemove' is not null or undefined
            (0, common_1.assertParamExists)('removeAuthorsFromWatchlist', 'watchlistAuthorsToRemove', watchlistAuthorsToRemove);
            const localVarPath = `/watchlists/{wid}/authors`
                .replace(`{${"wid"}}`, encodeURIComponent(String(wid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(watchlistAuthorsToRemove, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Will return remaining titles in watchlist on success.
         * @summary Remove a title from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeIdentFromWatchlist: (wid, ident, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wid' is not null or undefined
            (0, common_1.assertParamExists)('removeIdentFromWatchlist', 'wid', wid);
            // verify required parameter 'ident' is not null or undefined
            (0, common_1.assertParamExists)('removeIdentFromWatchlist', 'ident', ident);
            const localVarPath = `/watchlists/{wid}/{ident}`
                .replace(`{${"wid"}}`, encodeURIComponent(String(wid)))
                .replace(`{${"ident"}}`, encodeURIComponent(String(ident)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Removes the specified queries from the list and will return the new content of the watchlist on success.
         * @summary Remove queries from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistQueriesToRemove} watchlistQueriesToRemove Payload in JSON format.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQueriesFromWatchlist: (wid, watchlistQueriesToRemove, partition, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wid' is not null or undefined
            (0, common_1.assertParamExists)('removeQueriesFromWatchlist', 'wid', wid);
            // verify required parameter 'watchlistQueriesToRemove' is not null or undefined
            (0, common_1.assertParamExists)('removeQueriesFromWatchlist', 'watchlistQueriesToRemove', watchlistQueriesToRemove);
            const localVarPath = `/watchlists/{wid}/queries`
                .replace(`{${"wid"}}`, encodeURIComponent(String(wid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (partition !== undefined) {
                localVarQueryParameter['partition'] = partition;
            }
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(watchlistQueriesToRemove, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Will return the remaining watchlists on success.
         * @summary Remove a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWatchlist: (wid, format, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'wid' is not null or undefined
            (0, common_1.assertParamExists)('removeWatchlist', 'wid', wid);
            const localVarPath = `/watchlists/{wid}`
                .replace(`{${"wid"}}`, encodeURIComponent(String(wid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new url_1.URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BasicAuth required
            // http basic authentication required
            (0, common_1.setBasicAuthToObject)(localVarRequestOptions, configuration);
            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.WatchlistsApiAxiosParamCreator = WatchlistsApiAxiosParamCreator;
/**
 * WatchlistsApi - functional programming interface
 * @export
 */
const WatchlistsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.WatchlistsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Will return new content of watchlist on success. Either one of the properties `titles`, `authors`, or `queries` is required in payload json. Path parameter `wid` specifies the watchlist, to which items are to be added.
         * @summary Add one or more items to a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistItemsToAdd} watchlistItemsToAdd Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemWatchlist(wid, watchlistItemsToAdd, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addItemWatchlist(wid, watchlistItemsToAdd, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Will return the new Watchlist ID on success.
         * @summary Add a new watchlist
         * @param {WatchlistCreation} watchlistCreation Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWatchlist(watchlistCreation, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addWatchlist(watchlistCreation, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recent messages for all titles in a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForWatchlists(wid, type, source, lang, score, searchTerm, startDate, endDate, limit, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getMessagesForWatchlists(wid, type, source, lang, score, searchTerm, startDate, endDate, limit, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Buzz and sentiment for all titles in watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistContentForWatchlists(wid, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWatchlistContentForWatchlists(wid, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieve existing watchlists
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistsInventory(format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getWatchlistsInventory(format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Removes the specified authors from the list and will return the new content of the watchlist on success.
         * @summary Remove authors from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistAuthorsToRemove} watchlistAuthorsToRemove Payload in JSON format.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAuthorsFromWatchlist(wid, watchlistAuthorsToRemove, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeAuthorsFromWatchlist(wid, watchlistAuthorsToRemove, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Will return remaining titles in watchlist on success.
         * @summary Remove a title from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeIdentFromWatchlist(wid, ident, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeIdentFromWatchlist(wid, ident, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Removes the specified queries from the list and will return the new content of the watchlist on success.
         * @summary Remove queries from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistQueriesToRemove} watchlistQueriesToRemove Payload in JSON format.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQueriesFromWatchlist(wid, watchlistQueriesToRemove, partition, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeQueriesFromWatchlist(wid, watchlistQueriesToRemove, partition, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Will return the remaining watchlists on success.
         * @summary Remove a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWatchlist(wid, format, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.removeWatchlist(wid, format, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.WatchlistsApiFp = WatchlistsApiFp;
/**
 * WatchlistsApi - factory interface
 * @export
 */
const WatchlistsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.WatchlistsApiFp)(configuration);
    return {
        /**
         * Will return new content of watchlist on success. Either one of the properties `titles`, `authors`, or `queries` is required in payload json. Path parameter `wid` specifies the watchlist, to which items are to be added.
         * @summary Add one or more items to a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistItemsToAdd} watchlistItemsToAdd Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addItemWatchlist(wid, watchlistItemsToAdd, format, options) {
            return localVarFp.addItemWatchlist(wid, watchlistItemsToAdd, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return the new Watchlist ID on success.
         * @summary Add a new watchlist
         * @param {WatchlistCreation} watchlistCreation Payload in JSON format.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addWatchlist(watchlistCreation, format, options) {
            return localVarFp.addWatchlist(watchlistCreation, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recent messages for all titles in a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
         * @param {string} [source] Allows to restrict returned messages to a specific source.
         * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
         * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
         * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
         * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
         * @param {number} [limit] Restricts the number of returned data entries.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessagesForWatchlists(wid, type, source, lang, score, searchTerm, startDate, endDate, limit, partition, format, options) {
            return localVarFp.getMessagesForWatchlists(wid, type, source, lang, score, searchTerm, startDate, endDate, limit, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Buzz and sentiment for all titles in watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistContentForWatchlists(wid, partition, format, options) {
            return localVarFp.getWatchlistContentForWatchlists(wid, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieve existing watchlists
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWatchlistsInventory(format, options) {
            return localVarFp.getWatchlistsInventory(format, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the specified authors from the list and will return the new content of the watchlist on success.
         * @summary Remove authors from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistAuthorsToRemove} watchlistAuthorsToRemove Payload in JSON format.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAuthorsFromWatchlist(wid, watchlistAuthorsToRemove, partition, format, options) {
            return localVarFp.removeAuthorsFromWatchlist(wid, watchlistAuthorsToRemove, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return remaining titles in watchlist on success.
         * @summary Remove a title from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeIdentFromWatchlist(wid, ident, partition, format, options) {
            return localVarFp.removeIdentFromWatchlist(wid, ident, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Removes the specified queries from the list and will return the new content of the watchlist on success.
         * @summary Remove queries from a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {WatchlistQueriesToRemove} watchlistQueriesToRemove Payload in JSON format.
         * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeQueriesFromWatchlist(wid, watchlistQueriesToRemove, partition, format, options) {
            return localVarFp.removeQueriesFromWatchlist(wid, watchlistQueriesToRemove, partition, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Will return the remaining watchlists on success.
         * @summary Remove a watchlist
         * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
         * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeWatchlist(wid, format, options) {
            return localVarFp.removeWatchlist(wid, format, options).then((request) => request(axios, basePath));
        },
    };
};
exports.WatchlistsApiFactory = WatchlistsApiFactory;
/**
 * WatchlistsApi - object-oriented interface
 * @export
 * @class WatchlistsApi
 * @extends {BaseAPI}
 */
class WatchlistsApi extends base_1.BaseAPI {
    /**
     * Will return new content of watchlist on success. Either one of the properties `titles`, `authors`, or `queries` is required in payload json. Path parameter `wid` specifies the watchlist, to which items are to be added.
     * @summary Add one or more items to a watchlist
     * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
     * @param {WatchlistItemsToAdd} watchlistItemsToAdd Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    addItemWatchlist(wid, watchlistItemsToAdd, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).addItemWatchlist(wid, watchlistItemsToAdd, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Will return the new Watchlist ID on success.
     * @summary Add a new watchlist
     * @param {WatchlistCreation} watchlistCreation Payload in JSON format.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    addWatchlist(watchlistCreation, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).addWatchlist(watchlistCreation, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recent messages for all titles in a watchlist
     * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
     * @param {'adhoc' | 'blog' | 'comments' | 'filings' | 'forum_posts' | 'news' | 'tweets' | 'videos' | 'all'} [type]
     * @param {string} [source] Allows to restrict returned messages to a specific source.
     * @param {string} [lang] Allows to restrict returned messages to a specific language. Expects lowercase two-letter language codes, e.g. &#x60;en&#x60; or &#x60;zh&#x60;.
     * @param {number} [score] Allows to restrict returned messages by author score (reputation). Can be used to only retrieve messages from more reputable authors, for instance. Works by only returning messages from authors with score greater than or equal the given value.
     * @param {string} [searchTerm] Allows to restrict returned messages to a specific search term, which has to appear either in the subject or body of the message.
     * @param {string} [startDate] A date string or number which sets the earliest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {string} [endDate] A date string or number which sets the latest time for which historic data should be returned. If a string is used the date pattern should follow ISO 8601. If number is used it should be unixtime to the second. Server time is Europe/Berlin thus all date strings provided without timezone will be matched to Europe/Berlin as well.
     * @param {number} [limit] Restricts the number of returned data entries.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    getMessagesForWatchlists(wid, type, source, lang, score, searchTerm, startDate, endDate, limit, partition, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).getMessagesForWatchlists(wid, type, source, lang, score, searchTerm, startDate, endDate, limit, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Buzz and sentiment for all titles in watchlist
     * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    getWatchlistContentForWatchlists(wid, partition, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).getWatchlistContentForWatchlists(wid, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieve existing watchlists
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    getWatchlistsInventory(format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).getWatchlistsInventory(format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes the specified authors from the list and will return the new content of the watchlist on success.
     * @summary Remove authors from a watchlist
     * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
     * @param {WatchlistAuthorsToRemove} watchlistAuthorsToRemove Payload in JSON format.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    removeAuthorsFromWatchlist(wid, watchlistAuthorsToRemove, partition, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).removeAuthorsFromWatchlist(wid, watchlistAuthorsToRemove, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Will return remaining titles in watchlist on success.
     * @summary Remove a title from a watchlist
     * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
     * @param {string} ident Reference to a title's identity. Can be either StockPulse ID, ISIN code, Yahoo Finance code, Bloomberg code, or currency pair (e. g. EURUSD).
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    removeIdentFromWatchlist(wid, ident, partition, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).removeIdentFromWatchlist(wid, ident, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Removes the specified queries from the list and will return the new content of the watchlist on success.
     * @summary Remove queries from a watchlist
     * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
     * @param {WatchlistQueriesToRemove} watchlistQueriesToRemove Payload in JSON format.
     * @param {'10minute' | '1minute' | 'daily_5am' | 'daily_2pm' | 'daily_5pm' | 'hourly_shortterm' | '10minute_score_2' | '10minute_score_4' | 'daily_5am_score_2' | 'daily_5am_score_3' | 'daily_5am_score_4' | 'daily_5am_score_5' | 'hourly_reddit' | '10minute_reddit' | 'daily_5am_reddit' | '10minute_reddit_wallstreetbets' | '10minute_stocktwits' | 'daily_5am_stocktwits' | 'daily_5am_reddit_wallstreetbets' | 'daily_3am' | '10minute_investing' | 'daily_5am_investing' | '10minute_xueqiu' | 'daily_5am_xueqiu' | '10minute_twitter' | 'daily_5am_twitter' | 'daily_5am_discord' | '10minute_discord' | 'daily_2pm_discord' | 'daily_5pm_telegram' | 'daily_5am_telegram' | 'daily_5pm_tiktok' | 'daily_5am_tiktok' | 'daily_5pm_discord' | 'daily_5am_youtube' | 'daily_5pm_youtube' | 'daily_5am_hotcopper' | 'daily_5pm_hotcopper' | 'daily_5am_4chan' | 'daily_5pm_4chan' | 'daily_5am_coinmarketcap' | 'daily_5pm_coinmarketcap'} [partition] Defines which time unit / window is returned, e. g. for &#x60;daily_5am&#x60; time span returned is 24h and snapshot time is 5am Europe/Berlin.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    removeQueriesFromWatchlist(wid, watchlistQueriesToRemove, partition, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).removeQueriesFromWatchlist(wid, watchlistQueriesToRemove, partition, format, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Will return the remaining watchlists on success.
     * @summary Remove a watchlist
     * @param {number} wid Watchlist ID as provided from endpoint /watchlists.
     * @param {'json' | 'jsonc' | 'xml' | 'csv'} [format] Return format in which data are returned for the request, default is json.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WatchlistsApi
     */
    removeWatchlist(wid, format, options) {
        return (0, exports.WatchlistsApiFp)(this.configuration).removeWatchlist(wid, format, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.WatchlistsApi = WatchlistsApi;
